// // import { useEffect, useState, useMemo, useCallback } from "react";
// // import { IPDCWelcomeMessage } from "../../../components";
// // import {
// //   Container,
// //   Grid,
// //   Card,
// //   CardContent,
// //   Typography,
// //   Box,
// //   Paper,
// //   Button,
// //   IconButton,
// //   Avatar,
// //   Divider,
// //   LinearProgress,
// //   Tooltip,
// //   Chip,
// //   TextField,
// //   InputAdornment,
// //   MenuItem,
// //   FormControl,
// //   InputLabel,
// //   Select,
// //   CircularProgress,
// //   ToggleButton,
// //   ToggleButtonGroup
// // } from "@mui/material";
// // import {
// //   TrendingUp as TrendingUpIcon,
// //   TrendingDown as TrendingDownIcon,
// //   Business as BusinessIcon,
// //   People as PeopleIcon,
// //   AttachMoney as MoneyIcon,
// //   Assessment as AssessmentIcon,
// //   Receipt as ReceiptIcon,
// //   AccountBalance as AccountBalanceIcon,
// //   WarningAmber as WarningIcon,
// //   Download as DownloadIcon,
// //   Refresh as RefreshIcon,
// //   ArrowUpward as ArrowUpwardIcon,
// //   ArrowDownward as ArrowDownwardIcon,
// //   Inventory as InventoryIcon,
// //   Store as StoreIcon,
// //   LocalShipping as ExportIcon,
// //   AssignmentReturn as ImportIcon,
// //   Link as LinkageIcon,
// //   SwapHoriz as SubstitutionIcon,
// //   Work as WorkIcon,
// //   Female as FemaleIcon,
// //   Male as MaleIcon,
// //   LocationOn as LocationOnIcon,
// //   CalendarToday as CalendarIcon,
// //   PieChart as PieChartIcon,
// //   BarChart as BarChartIcon,
// //   ShowChart as ShowChartIcon,
// //   Search as SearchIcon,
// //   Clear as ClearIcon,
// //   Description as DescriptionIcon,
// //   DonutLarge as DonutIcon,
// //   Timeline as TimelineIcon,
// //   StackedBarChart as StackedBarIcon
// // } from "@mui/icons-material";
// // import { format } from "date-fns";
// // import { GetDataFromApiWithParams } from "../../../services/api/ExecuteApiRequests";

// // // ==================== HELPER FUNCTIONS ====================
// // const toNumber = (value) => {
// //   if (typeof value === 'number' && !isNaN(value)) return value;
// //   if (typeof value === 'string') {
// //     const num = parseFloat(value.replace(/,/g, ''));
// //     return isNaN(num) ? 0 : num;
// //   }
// //   return 0;
// // };

// // const formatNumber = (number) => {
// //   const num = toNumber(number);
// //   if (num === 0) return "0";
// //   return new Intl.NumberFormat('en-US').format(num);
// // };

// // const formatCurrency = (amount) => {
// //   if (!amount && amount !== 0) return "$0";
// //   return new Intl.NumberFormat('en-US', {
// //     style: 'currency',
// //     currency: 'USD',
// //     minimumFractionDigits: 0,
// //     maximumFractionDigits: 0,
// //   }).format(amount);
// // };

// // const formatCurrencyETB = (amount) => {
// //   if (!amount && amount !== 0) return "Br0";
// //   return `${formatNumber(amount)}`;
// // };

// // const normalizeCurrency = (paymentMode) => {
// //   if (!paymentMode) return "unknown";
// //   const mode = paymentMode.toLowerCase();
// //   if (mode === "usd") return "usd";
// //   if (mode === "birr" || mode === "etb") return "etb";
// //   return mode;
// // };

// // // Month names mapping
// // const monthNames = {
// //   "01": "Jan", "02": "Feb", "03": "Mar", "04": "Apr", "05": "May", "06": "Jun",
// //   "07": "Jul", "08": "Aug", "09": "Sep", "10": "Oct", "11": "Nov", "12": "Dec"
// // };

// // // ==================== DONUT CHART COMPONENT ====================
// // const DonutChartComponent = ({ title, data, colors, formatValue, total }) => {
// //   const items = Object.keys(data);
// //   const totalValue = total || items.reduce((sum, key) => sum + (data[key] || 0), 0);
// //   const donutColors = colors || [
// //     '#005F73', '#0A9396', '#94D2BD', '#E9D8A6', '#EE9B00', '#CA6702', '#BB3E03', '#AE2012', '#9B2226', '#2D6A4F',
// //     '#40916C', '#52B788', '#74C69D', '#1B4332', '#081C15', '#3F37C9', '#4361EE', '#4895EF', '#4CC9F0', '#7209B7',
// //     '#B5179E', '#F72585', '#4A4E69', '#9A8C98', '#C9ADA7'
// //   ];
  
// //   if (items.length === 0 || totalValue === 0) {
// //     return (
// //       <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#fafafa', borderRadius: 2, height: '100%' }}>
// //         <Typography variant="body2" color="textSecondary">No data available</Typography>
// //       </Box>
// //     );
// //   }
  
// //   let startAngle = 0;
// //   const centerX = 80, centerY = 80, radius = 55;
// //   const svgSize = 180;
  
// //   return (
// //     <Box sx={{ p: 0.5, bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
// //       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1, fontSize: '1rem' }}>{title}</Typography>
// //       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
// //         <Box sx={{ position: 'relative', width: svgSize, height: svgSize }}>
// //           <svg width={svgSize} height={svgSize} viewBox={`0 0 ${svgSize} ${svgSize}`}>
// //             {items.map((key, index) => {
// //               const value = data[key] || 0;
// //               const percentage = totalValue > 0 ? (value / totalValue) * 100 : 0;
// //               const angle = (percentage / 100) * 360;
// //               const endAngle = startAngle + angle;
              
// //               const startRad = (startAngle * Math.PI) / 180;
// //               const endRad = (endAngle * Math.PI) / 180;
              
// //               const x1 = centerX + radius * Math.cos(startRad);
// //               const y1 = centerY + radius * Math.sin(startRad);
// //               const x2 = centerX + radius * Math.cos(endRad);
// //               const y2 = centerY + radius * Math.sin(endRad);
              
// //               const largeArcFlag = angle > 180 ? 1 : 0;
// //               const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
              
// //               const slice = <path key={key} d={pathData} fill={donutColors[index % donutColors.length]} stroke="white" strokeWidth="2" />;
// //               startAngle = endAngle;
// //               return slice;
// //             })}
// //             <circle cx={centerX} cy={centerY} r="32" fill="white" />
// //             <text x={centerX} y={centerY - 5} textAnchor="middle" fontSize="7" fill="#666">Total</text>
// //             <text x={centerX} y={centerY + 8} textAnchor="middle" fontSize="8" fontWeight="bold" fill="#1976d2">{formatValue(totalValue)}</text>
// //           </svg>
// //         </Box>
// //         <Box sx={{ minWidth: 120, maxHeight: 160, overflowY: 'auto' }}>
// //           {items.slice(0, 5).map((key, index) => {
// //             const value = data[key] || 0;
// //             const percentage = totalValue > 0 ? ((value / totalValue) * 100).toFixed(1) : 0;
// //             return (
// //               <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 0.5 }}>
// //                 <Box sx={{ width: 10, height: 10, bgcolor: donutColors[index % donutColors.length], borderRadius: 1 }} />
// //                 <Typography variant="caption" sx={{ fontSize: '0.8rem', flex: 1 }}>{key.length > 15 ? key.substring(0, 12) + '...' : key}</Typography>
// //                 <Typography variant="caption" sx={{ fontSize: '0.8rem' }}>{formatValue(value)} ({percentage}%)</Typography>
// //               </Box>
// //             );
// //           })}
// //         </Box>
// //       </Box>
// //     </Box>
// //   );
// // };

// // // ==================== HORIZONTAL BAR CHART ====================
// // const HorizontalBarChart = ({ title, data, dataKey, color, formatValue }) => {
// //   const items = Object.keys(data);
// //   const maxValue = Math.max(...Object.values(data).map(d => d[dataKey] || 0), 0);
  
// //   if (items.length === 0 || maxValue === 0) {
// //     return (
// //       <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
// //         <Typography variant="body2" color="textSecondary">No data available</Typography>
// //       </Box>
// //     );
// //   }
  
// //   return (
// //     <Box sx={{ p: 1.5, bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
// //       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1.5, fontSize: '1rem' }}>{title}</Typography>
// //       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
// //         {items.slice(0, 6).map((item) => {
// //           const value = data[item][dataKey] || 0;
// //           const percentage = maxValue > 0 ? (value / maxValue) * 100 : 0;
          
// //           return (
// //             <Box key={item}>
// //               <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
// //                 <Typography variant="caption" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>{item.length > 15 ? item.substring(0, 12) + '...' : item}</Typography>
// //                 <Typography variant="caption" sx={{ fontSize: '0.8rem', fontWeight: 'bold', color: color }}>{formatValue(value)}</Typography>
// //               </Box>
// //               <LinearProgress
// //                 variant="determinate"
// //                 value={percentage}
// //                 sx={{
// //                   height: 8,
// //                   borderRadius: 4,
// //                   backgroundColor: '#e0e0e0',
// //                   '& .MuiLinearProgress-bar': { backgroundColor: color, borderRadius: 4 }
// //                 }}
// //               />
// //             </Box>
// //           );
// //         })}
// //       </Box>
// //     </Box>
// //   );
// // };

// // // ==================== MONTHLY LINE CHART COMPONENT ====================
// // const MonthlyLineChart = ({ title, monthlyData, formatValue, color }) => {
// //   const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
// //   const values = months.map(month => monthlyData[month] || 0);
// //   const maxValue = Math.max(...values, 1);
  
// //   if (maxValue === 0) {
// //     return (
// //       <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#e3f2fd', borderRadius: 2, height: '100%' }}>
// //         <Typography variant="body2" color="textSecondary">No monthly data available</Typography>
// //       </Box>
// //     );
// //   }
  
// //   const chartHeight = 200;
// //   const chartWidth = 500;
// //   const padding = { top: 20, right: 30, bottom: 35, left: 50 };
  
// //   return (
// //     <Box sx={{ p: 1.5, bgcolor: '#e3f2fd', borderRadius: 2, height: '100%' }}>
// //       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1, fontSize: '0.7rem' }}>{title}</Typography>
// //       <svg width="100%" height={chartHeight} viewBox={`0 0 ${chartWidth} ${chartHeight}`} preserveAspectRatio="xMidYMid meet">
// //         {[0, 25, 50, 75, 100].map((percent) => {
// //           const y = chartHeight - padding.bottom - (percent / 100) * (chartHeight - padding.top - padding.bottom);
// //           const value = (maxValue * percent) / 100;
// //           return (
// //             <g key={percent}>
// //               <line x1={padding.left} y1={y} x2={chartWidth - padding.right} y2={y} stroke="#e0e0e0" strokeWidth="0.8" strokeDasharray="3" />
// //               <text x={padding.left - 8} y={y} textAnchor="end" fontSize="7" fill="#666">{formatValue(value)}</text>
// //             </g>
// //           );
// //         })}
        
// //         <polygon
// //           points={`${padding.left},${chartHeight - padding.bottom} ${months.map((month, idx) => {
// //             const x = padding.left + (idx / (months.length - 1)) * (chartWidth - padding.left - padding.right);
// //             const value = monthlyData[month] || 0;
// //             const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
// //             return `${x},${y}`;
// //           }).join(' ')} ${chartWidth - padding.right},${chartHeight - padding.bottom}`}
// //           fill={`${color}20`}
// //         />
        
// //         <polyline
// //           points={months.map((month, idx) => {
// //             const x = padding.left + (idx / (months.length - 1)) * (chartWidth - padding.left - padding.right);
// //             const value = monthlyData[month] || 0;
// //             const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
// //             return `${x},${y}`;
// //           }).join(' ')}
// //           fill="none"
// //           stroke={color}
// //           strokeWidth="2.5"
// //         />
        
// //         {months.map((month, idx) => {
// //           const x = padding.left + (idx / (months.length - 1)) * (chartWidth - padding.left - padding.right);
// //           const value = monthlyData[month] || 0;
// //           const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
// //           return (
// //             <g key={month}>
// //               <circle cx={x} cy={y} r="4" fill={color} stroke="white" strokeWidth="2" />
// //               {value > 0 && (
// //                 <text x={x} y={y - 8} textAnchor="middle" fontSize="7" fill={color} fontWeight="bold">
// //                   {formatValue(value)}
// //                 </text>
// //               )}
// //             </g>
// //           );
// //         })}
        
// //         {months.map((month, idx) => {
// //           const x = padding.left + (idx / (months.length - 1)) * (chartWidth - padding.left - padding.right);
// //           return (
// //             <text key={month} x={x} y={chartHeight - padding.bottom + 15} textAnchor="middle" fontSize="7" fontWeight="500">{month}</text>
// //           );
// //         })}
        
// //         <line x1={padding.left} y1={padding.top} x2={padding.left} y2={chartHeight - padding.bottom} stroke="#999" strokeWidth="1" />
// //         <line x1={padding.left} y1={chartHeight - padding.bottom} x2={chartWidth - padding.right} y2={chartHeight - padding.bottom} stroke="#999" strokeWidth="1" />
// //       </svg>
// //     </Box>
// //   );
// // };

// // // ==================== TRADE MULTI-BAR CHART COMPONENT ====================
// // const TradeMultiBarChart = ({ title, data, formatValue, recentYear }) => {
// //   const parks = Object.keys(data);
// //   const maxValue = Math.max(...Object.values(data).map(d => 
// //     Math.max(d.export || 0, d.import || 0, d.importSubstitution || 0)
// //   ), 0);
  
// //   if (parks.length === 0 || maxValue === 0) {
// //     return (
// //       <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#e3f2fd', borderRadius: 2, height: '100%' }}>
// //         <Typography variant="body2" color="textSecondary">No trade data available</Typography>
// //       </Box>
// //     );
// //   }
  
// //   return (
// //     <Box sx={{ p: 1.5, bgcolor: '#e3f2fd', borderRadius: 2, height: '100%' }}>
// //       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1.5, fontSize: '0.7rem' }}>
// //         {title} ({recentYear})
// //       </Typography>
// //       <Box sx={{ overflowX: 'auto' }}>
// //         <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, minHeight: 350, justifyContent: 'center', flexWrap: 'wrap', minWidth: 500 }}>
// //           {parks.slice(0, 6).map((park) => {
// //             const exportValue = data[park]?.export || 0;
// //             const importValue = data[park]?.import || 0;
// //             const importSubValue = data[park]?.importSubstitution || 0;
            
// //             const heightExport = maxValue > 0 ? (exportValue / maxValue) * 200 : 0;
// //             const heightImport = maxValue > 0 ? (importValue / maxValue) * 200 : 0;
// //             const heightImportSub = maxValue > 0 ? (importSubValue / maxValue) * 200 : 0;
            
// //             return (
// //               <Tooltip 
// //                 key={park} 
// //                 title={
// //                   <Box>
// //                     <Typography variant="subtitle2">{park}</Typography>
// //                     <Typography variant="body2">Export: {formatValue(exportValue)}</Typography>
// //                     <Typography variant="body2">Import: {formatValue(importValue)}</Typography>
// //                     <Typography variant="body2">Import Substitution: {formatValue(importSubValue)}</Typography>
// //                   </Box>
// //                 } 
// //                 arrow 
// //                 placement="top"
// //               >
// //                 <Box sx={{ textAlign: 'center', minWidth: 80 }}>
// //                   <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center', alignItems: 'flex-end', height: 220 }}>
// //                     <Box sx={{ position: 'relative', height: heightExport, width: '28px', bgcolor: '#4caf50', borderRadius: '3px 3px 0 0', transition: 'all 0.3s ease', '&:hover': { opacity: 0.8 } }}>
// //                       {heightExport > 25 && (
// //                         <Typography variant="caption" sx={{ position: 'absolute', bottom: heightExport - 18, left: '50%', transform: 'translateX(-50%)', fontSize: '7px', fontWeight: 'bold', color: 'white', whiteSpace: 'nowrap' }}>
// //                           {formatValue(exportValue)}
// //                         </Typography>
// //                       )}
// //                     </Box>
// //                     <Box sx={{ position: 'relative', height: heightImport, width: '28px', bgcolor: '#ff9800', borderRadius: '3px 3px 0 0', transition: 'all 0.3s ease', '&:hover': { opacity: 0.8 } }}>
// //                       {heightImport > 25 && (
// //                         <Typography variant="caption" sx={{ position: 'absolute', bottom: heightImport - 18, left: '50%', transform: 'translateX(-50%)', fontSize: '7px', fontWeight: 'bold', color: 'white', whiteSpace: 'nowrap' }}>
// //                           {formatValue(importValue)}
// //                         </Typography>
// //                       )}
// //                     </Box>
// //                     <Box sx={{ position: 'relative', height: heightImportSub, width: '28px', bgcolor: '#9c27b0', borderRadius: '3px 3px 0 0', transition: 'all 0.3s ease', '&:hover': { opacity: 0.8 } }}>
// //                       {heightImportSub > 25 && (
// //                         <Typography variant="caption" sx={{ position: 'absolute', bottom: heightImportSub - 18, left: '50%', transform: 'translateX(-50%)', fontSize: '7px', fontWeight: 'bold', color: 'white', whiteSpace: 'nowrap' }}>
// //                           {formatValue(importSubValue)}
// //                         </Typography>
// //                       )}
// //                     </Box>
// //                   </Box>
// //                   <Typography variant="caption" sx={{ mt: 0.5, display: 'block', fontWeight: 'bold', fontSize: '0.6rem' }}>
// //                     {park.length > 12 ? park.substring(0, 10) + '...' : park}
// //                   </Typography>
// //                 </Box>
// //               </Tooltip>
// //             );
// //           })}
// //         </Box>
// //       </Box>
// //       <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mt: 2 }}>
// //         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
// //           <Box sx={{ width: 16, height: 16, bgcolor: '#4caf50', borderRadius: 1 }} />
// //           <Typography variant="caption" sx={{ fontSize: '0.6rem' }}>Export</Typography>
// //         </Box>
// //         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
// //           <Box sx={{ width: 16, height: 16, bgcolor: '#ff9800', borderRadius: 1 }} />
// //           <Typography variant="caption" sx={{ fontSize: '0.6rem' }}>Import</Typography>
// //         </Box>
// //         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
// //           <Box sx={{ width: 16, height: 16, bgcolor: '#9c27b0', borderRadius: 1 }} />
// //           <Typography variant="caption" sx={{ fontSize: '0.6rem' }}>Import Substitution</Typography>
// //         </Box>
// //       </Box>
// //     </Box>
// //   );
// // };

// // // ==================== STACKED BAR CHART ====================
// // const StackedBarChartComponent = ({ title, data, formatValue }) => {
// //   const items = Object.keys(data);
// //   const maxValue = Math.max(...Object.values(data).map(d => (d.female || 0) + (d.male || 0)), 0);
  
// //   if (items.length === 0 || maxValue === 0) {
// //     return (
// //       <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
// //         <Typography variant="body2" color="textSecondary">No employment data available</Typography>
// //       </Box>
// //     );
// //   }
  
// //   return (
// //     <Box sx={{ p: 1.5, bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
// //       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1.5, fontSize: '0.9rem' }}>{title}</Typography>
// //       <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1, minHeight: 220, justifyContent: 'center', flexWrap: 'wrap' }}>
// //         {items.slice(0, 5).map((item) => {
// //           const femaleValue = data[item]?.female || 0;
// //           const maleValue = data[item]?.male || 0;
// //           const totalValue = femaleValue + maleValue;
// //           const heightFemale = maxValue > 0 ? (femaleValue / maxValue) * 150 : 0;
// //           const heightMale = maxValue > 0 ? (maleValue / maxValue) * 150 : 0;
          
// //           return (
// //             <Tooltip key={item} title={`${item}: Female ${formatValue(femaleValue)}, Male ${formatValue(maleValue)}`} arrow placement="top">
// //               <Box sx={{ textAlign: 'center', minWidth: 60 }}>
// //                 <Box sx={{ display: 'flex', gap: 0.3, justifyContent: 'center', alignItems: 'flex-end' }}>
// //                   <Box sx={{ height: heightFemale, width: '22px', bgcolor: '#e91e63', borderRadius: '2px 2px 0 0' }} />
// //                   <Box sx={{ height: heightMale, width: '22px', bgcolor: '#2196f3', borderRadius: '2px 2px 0 0' }} />
// //                 </Box>
// //                 <Typography variant="caption" sx={{ mt: 0.5, display: 'block', fontWeight: 'bold', fontSize: '0.8rem' }}>{item.length > 10 ? item.substring(0, 8) + '...' : item}</Typography>
// //                 <Typography variant="caption" sx={{ fontSize: '0.8rem', color: '#666' }}>Total: {formatValue(totalValue)}</Typography>
// //               </Box>
// //             </Tooltip>
// //           );
// //         })}
// //       </Box>
// //       <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 1 }}>
// //         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}><Box sx={{ width: 12, height: 12, bgcolor: '#e91e63', borderRadius: 1 }} /><Typography variant="caption" sx={{ fontSize: '0.6rem' }}>Female</Typography></Box>
// //         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}><Box sx={{ width: 12, height: 12, bgcolor: '#2196f3', borderRadius: 1 }} /><Typography variant="caption" sx={{ fontSize: '0.6rem' }}>Male</Typography></Box>
// //       </Box>
// //     </Box>
// //   );
// // };

// // // ==================== MAIN DASHBOARD ====================
// // export default function InvestorAftercareDashboard() {
// //   const [loading, setLoading] = useState(true);
// //   const [currentTime, setCurrentTime] = useState(new Date());
  
// //   // Data States
// //   const [revenueData, setRevenueData] = useState([]);
// //   const [arrearsData, setArrearsData] = useState([]);
// //   const [employmentData, setEmploymentData] = useState([]);
// //   const [tradeData, setTradeData] = useState([]);
// //   const [contractsData, setContractsData] = useState([]);
// //   const [investorsData, setInvestorsData] = useState([]);
  
// //   // Filter States
// //   const [searchTerm, setSearchTerm] = useState("");
// //   const [selectedPark, setSelectedPark] = useState("all");
// //   const [parksList, setParksList] = useState(["all"]);
// //   const [selectedYear, setSelectedYear] = useState("all");
// //   const [yearsList, setYearsList] = useState(["all"]);

// //   // Update time
// //   useEffect(() => {
// //     const timer = setInterval(() => setCurrentTime(new Date()), 60000);
// //     return () => clearInterval(timer);
// //   }, []);

// //   // Fetch Revenue Data
// //   useEffect(() => {
// //     const fetchRevenue = async () => {
// //       try {
// //         const resultData = await GetDataFromApiWithParams(`finances/revenuereport`);
// //         let dataArray = [];
// //         if (resultData && Array.isArray(resultData)) dataArray = resultData;
// //         else if (resultData?.data && Array.isArray(resultData.data)) dataArray = resultData.data;
// //         else if (resultData?.results && Array.isArray(resultData.results)) dataArray = resultData.results;
// //         console.log("KOKOKOKOKKOK",resultData)
// //         // console.log("KOKOKOKOKKOK",resultData.map(item=>item.payment_date))
// //         const formattedData = dataArray.map((item, index) => ({
// //           id: item.id || index,
// //           company_name: item.company_name || item.tenant_name || "N/A",
// //           park_name: item.park_name || item.park || "N/A",
// //           payment_mode: item.payment_mode || "USD",
// //           amount: parseFloat(item.amount) || parseFloat(item.payment_amount) || 0,
// //           month: item.month || (item.transaction_date ? format(new Date(item.transaction_date), 'MM') : "01"),
// //           year: new Date(item.payment_date).getFullYear() || (item.transaction_date ? format(new Date(item.transaction_date), 'yyyy') : "2026")
// //         }));
// //         setRevenueData(formattedData);
// //       } catch (error) {
// //         console.error("Failed to fetch revenue data:", error);
// //       }
// //     };
// //     fetchRevenue();
// //   }, []);

// //   // Fetch Arrear Data
// //   useEffect(() => {
// //     const fetchArrear = async () => {
// //       try {
// //         const resultData = await GetDataFromApiWithParams(`finances/arrearreport`);
// //         let dataArray = [];
// //         if (resultData && Array.isArray(resultData)) dataArray = resultData;
// //         else if (resultData?.data && Array.isArray(resultData.data)) dataArray = resultData.data;
       
// //         const formattedData = resultData.map(item => ({
// //           id: item.agreement_id,
// //           company_name: item.company_name || "N/A",
// //           park_name: item.park_name || item.park || "N/A",
// //           payment_mode: item.payment_mode || "USD",
// //           outstanding: parseFloat(item.outstanding) || 0,
// //           overdue_days: item.overdue_date || 0,
// //           month: item.month || "01",
// //           year: item.payment_date || "2026"
// //         }));
// //         setArrearsData(formattedData);
// //       } catch (error) {
// //         console.error("Failed to fetch arrears data:", error);
// //       }
// //     };
// //     fetchArrear();
// //   }, []);

// //   // Fetch Employment Data
// //   // useEffect(() => {
// //   //   const fetchEmployment = async () => {
// //   //     try {
// //   //       const resultData = await GetDataFromApiWithParams(`investors/getemployment`);
// //   //       let dataArray = [];
// //   //       if (resultData && Array.isArray(resultData)) dataArray = resultData;
// //   //       else if (resultData?.data && Array.isArray(resultData.data)) dataArray = resultData.data;
        
// //   //       const formattedData = dataArray.map(item => ({
// //   //         id: item.id,
// //   //         investor_id: item.investor_id,
// //   //         company_name: item.company_name || `Company ${item.investor_id}`,
// //   //         park_name: item.park_name || "N/A",
// //   //         emp_labor_female: parseInt(item.emp_labor_female) || 0,
// //   //         emp_labor_male: parseInt(item.emp_labor_male) || 0,
// //   //         emp_prof_female: parseInt(item.emp_prof_female) || 0,
// //   //         emp_prof_male: parseInt(item.emp_prof_male) || 0,
// //   //         year: item.year || "2024",
// //   //         month: item.month || "01"
// //   //       }));
// //   //       setEmploymentData(formattedData);
// //   //     } catch (error) {
// //   //       console.error("Failed to fetch employment data:", error);
// //   //     }
// //   //   };
// //   //   fetchEmployment();
// //   // }, []);
// // //******************************************************************* */
// // // Fetch Employment Data - Modified
// // useEffect(() => {
// //   const fetchEmployment = async () => {
// //     try {
// //       // Fetch from both endpoints
// //       const [activityResult, employmentResult] = await Promise.all([
// //         GetDataFromApiWithParams(`investors/getemployment`),
// //         GetDataFromApiWithParams(`investors/getparkemployment`) // New endpoint for park_employment
// //       ]);
      
// //       let activityData = [];
// //       let parkEmploymentData = [];
      
// //       if (activityResult && Array.isArray(activityResult)) activityData = activityResult;
// //       else if (activityResult?.data && Array.isArray(activityResult.data)) activityData = activityResult.data;
      
// //       if (employmentResult && Array.isArray(employmentResult)) parkEmploymentData = employmentResult;
// //       else if (employmentResult?.data && Array.isArray(employmentResult.data)) parkEmploymentData = employmentResult.data;
      
// //       // Combine the data
// //       const combinedMap = new Map();
      
// //       // Add investor_activity data (created employment)
// //       activityData.forEach(item => {
// //         const key = item.investor_id || item.id;
// //         if (!combinedMap.has(key)) {
// //           combinedMap.set(key, {
// //             id: item.id || key,
// //             investor_id: key,
// //             company_name: item.company_name || `Company ${key}`,
// //             park_name: item.park_name || "N/A",
// //             emp_labor_female: 0,
// //             emp_labor_male: 0,
// //             emp_prof_female: 0,
// //             emp_prof_male: 0,
// //             year: item.year || "2024",
// //             month: item.month || "01"
// //           });
// //         }
// //         const existing = combinedMap.get(key);
// //         existing.emp_labor_female += parseInt(item.emp_labor_female) || 0;
// //         existing.emp_labor_male += parseInt(item.emp_labor_male) || 0;
// //         existing.emp_prof_female += parseInt(item.emp_prof_female) || 0;
// //         existing.emp_prof_male += parseInt(item.emp_prof_male) || 0;
// //       });
      
// //       // Add park_employment data (present employment)
// //       parkEmploymentData.forEach(item => {
// //         const key = item.investor_id || item.id;
// //         if (!combinedMap.has(key)) {
// //           combinedMap.set(key, {
// //             id: item.id || key,
// //             investor_id: key,
// //             company_name: item.company_name || `Company ${key}`,
// //             park_name: item.park_name || "N/A",
// //             emp_labor_female: 0,
// //             emp_labor_male: 0,
// //             emp_prof_female: 0,
// //             emp_prof_male: 0,
// //             year: item.year || "2024",
// //             month: item.month || "01"
// //           });
// //         }
// //         const existing = combinedMap.get(key);
// //         // Add present values
// //         existing.emp_labor_female += parseInt(item.labor_female) || 0;
// //         existing.emp_labor_male += parseInt(item.labor_male) || 0;
// //         existing.emp_prof_female += parseInt(item.professional_female) || 0;
// //         existing.emp_prof_male += parseInt(item.professional_male) || 0;
// //       });
      
// //       const combinedData = Array.from(combinedMap.values());
// //       setEmploymentData(combinedData);
      
// //     } catch (error) {
// //       console.error("Failed to fetch employment data:", error);
// //     }
// //   };
// //   fetchEmployment();
// // }, []);
// // //************************************************************** */
// //   // Fetch Trade Data
// //   useEffect(() => {
// //     const fetchTrade = async () => {
// //       try {
// //         const resultData = await GetDataFromApiWithParams(`investors/getemployment`);
// //         let dataArray = [];
// //         if (resultData && Array.isArray(resultData)) dataArray = resultData;
// //         else if (resultData?.data && Array.isArray(resultData.data)) dataArray = resultData.data;
        
// //         const formattedData = dataArray.map(item => ({
// //           id: item.id,
// //           investor_id: item.investor_id,
// //           park_name: item.park_name || "N/A",
// //           export_amount: parseFloat(String(item.export_amount || '0').replace(/[$,]/g, '')) || 0,
// //           import_amount: parseFloat(String(item.import || '0').replace(/[$,]/g, '')) || 0,
// //           linkage_amount: parseFloat(String(item.linkage_money || '0').replace(/[$,]/g, '')) || 0,
// //           import_substitution: parseFloat(String(item.import_substitution || '0').replace(/[$,]/g, '')) || 0,
// //           year: item.recorded_on ? new Date(item.recorded_on).getFullYear() : "2026"
// //         }));
// //         setTradeData(formattedData);
// //       } catch (error) {
// //         console.error("Failed to fetch trade data:", error);
// //       }
// //     };
// //     fetchTrade();
// //   }, []);

// //   // Fetch Contracts and Investors Data - FIXED VERSION
// //   useEffect(() => {
// //     const fetchData = async () => {
// //       try {
// //         const investorData = await GetDataFromApiWithParams(`investors/getinverstor`);
// //         const contractData = await GetDataFromApiWithParams(`agreements/allagreements`);
        
// //         let investors = [];
// //         let contracts = [];
        
// //         if (Array.isArray(investorData)) investors = investorData;
// //         else if (investorData?.data && Array.isArray(investorData.data)) investors = investorData.data;
        
// //         if (Array.isArray(contractData)) contracts = contractData;
// //         else if (contractData?.data && Array.isArray(contractData.data)) contracts = contractData.data;
        
// //         // FIXED: Include payment_mode from contract for each investor
// //         const transformedInvestors = investors.map(investor => {
// //           // Find matching contract to get payment_mode
// //           const matchingContract = contracts.find(c => 
// //             c.tenant_id === investor.id || 
// //             c.tenant_id === investor.investor_id ||
// //             c.investor_id === investor.id ||
// //             c.investor_id === investor.investor_id
// //           );
          
// //           return {
// //             id: investor.id || investor.investor_id,
// //             company_name: investor.company_name || "N/A",
// //             park_name: investor.park_name || "N/A",
// //             investment_type: investor.investment_type || "N/A",
// //             nationality: investor.nationality_origin || "Ethiopia",
// //             capital: parseFloat(investor.capital) || 0,
// //             payment_mode: matchingContract?.payment_mode || investor.payment_mode || "USD" // KEY FIX
// //           };
// //         });
        
// //         const transformedContracts = contracts.map(contract => ({
// //           id: contract.id || contract.agreement_id,
// //           company_name: contract.company_name || "N/A",
// //           park_name: contract.park_name || contract.park || "N/A",
// //           investment_type: contract.investment_type || "N/A",
// //           status: contract.status || "Active",
// //           monthly_rent: parseFloat(contract.monthly_rent) || 0,
// //           ownership_type: contract.ownership_type || "Leased"
// //         }));
        
// //         setInvestorsData(transformedInvestors);
// //         setContractsData(transformedContracts);
// //       } catch (error) {
// //         console.error("Failed to fetch data:", error);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     fetchData();
// //   }, []);

// //   // Generate unique parks and years
// //   useEffect(() => {
// //     const allParks = new Set();
// //     [...revenueData, ...arrearsData, ...employmentData, ...tradeData, ...investorsData, ...contractsData].forEach(item => {
// //       if (item.park_name && item.park_name !== "N/A") allParks.add(item.park_name);
// //     });
// //     setParksList(["all", ...Array.from(allParks).sort()]);
    
// //     const allYears = new Set();
// //     [...revenueData, ...arrearsData, ...employmentData, ...tradeData].forEach(item => {
// //       if (item.year) allYears.add(item.year);
// //     });
// //     setYearsList(["all", ...Array.from(allYears).sort().reverse()]);
// //   }, [revenueData, arrearsData, employmentData, tradeData, investorsData, contractsData]);

// //   // Filter data by park and year
// //   const filterByParkAndYear = useCallback((data, yearField = 'year', parkField = 'park_name') => {
// //     return data.filter(item => {
// //       const parkMatch = selectedPark === "all" || item[parkField] === selectedPark;
// //       const yearMatch = selectedYear === "all" || item[yearField] === selectedYear;
// //       const searchMatch = searchTerm === "" || 
// //         item.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
// //         item.park_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
// //         item.investor_id?.toString().includes(searchTerm);
// //       return parkMatch && yearMatch && searchMatch;
// //     });
// //   }, [selectedPark, selectedYear, searchTerm]);

// //  console.log("REVENUUUUUUUUUUUeeeeeeeeee", revenueData)
// //   const getMostRecentYear = useCallback(() => {
// //     const years = [...new Set(revenueData.map(r => r.year).filter(y => y && y !== "N/A"))];
// //     if (years.length === 0) return "2026";
// //     return years.sort().reverse()[0];
// //   }, [revenueData]);

// //   // Calculate metrics
// //   const metrics = useMemo(() => {
// //     const filteredRevenue = filterByParkAndYear(revenueData);
// //     const filteredArrears = filterByParkAndYear(arrearsData);
// //     const filteredEmployment = filterByParkAndYear(employmentData);
// //     const filteredTrade = tradeData;
// //     const filteredInvestors = filterByParkAndYear(investorsData, 'year', 'park_name');
// //     const filteredContracts = filterByParkAndYear(contractsData, 'year', 'park_name');
    
// //     // Revenue metrics
// //     const totalRevenueUSD = filteredRevenue.filter(r => normalizeCurrency(r.payment_mode) === "usd").reduce((sum, r) => sum + (r.amount || 0), 0);
// //     const totalRevenueETB = filteredRevenue.filter(r => normalizeCurrency(r.payment_mode) === "etb").reduce((sum, r) => sum + (r.amount || 0), 0);
// //     const totalOutstandingUSD = filteredArrears.filter(a => normalizeCurrency(a.payment_mode) === "usd").reduce((sum, a) => sum + (a.outstanding || 0), 0);
// //     const totalOutstandingETB = filteredArrears.filter(a => normalizeCurrency(a.payment_mode) === "etb").reduce((sum, a) => sum + (a.outstanding || 0), 0);
// //     const totalCollectedUSD = Math.max(0, totalRevenueUSD - totalOutstandingUSD);
// //     const collectionRate = totalRevenueUSD > 0 ? (totalCollectedUSD / totalRevenueUSD) * 100 : 0;
    
// //     // Employment metrics
// //     const totalLaborFemale = filteredEmployment.reduce((sum, e) => sum + (e.emp_labor_female || 0), 0);
// //     const totalLaborMale = filteredEmployment.reduce((sum, e) => sum + (e.emp_labor_male || 0), 0);
// //     const totalProfFemale = filteredEmployment.reduce((sum, e) => sum + (e.emp_prof_female || 0), 0);
// //     const totalProfMale = filteredEmployment.reduce((sum, e) => sum + (e.emp_prof_male || 0), 0);
// //     const totalEmployees = totalLaborFemale + totalLaborMale + totalProfFemale + totalProfMale;
    
// //     // Trade metrics
// //     const totalExport = filteredTrade.reduce((sum, t) => sum + (t.export_amount || 0), 0);
// //     const totalImport = filteredTrade.reduce((sum, t) => sum + (t.import_amount || 0), 0);
// //     const totalImportSubstitution = filteredTrade.reduce((sum, t) => sum + (t.import_substitution || 0), 0);
// //     const totalLinkage = filteredTrade.reduce((sum, t) => sum + (t.linkage_amount || 0), 0);
// //     const netTradeBalance = totalExport - totalImport;
    
// //     // Investor metrics - FIXED: Using normalizeCurrency for both USD and ETB
// //     const totalInvestors = filteredInvestors.length;
// //     const fdiCount = filteredInvestors.filter(i => i.nationality && i.nationality.toLowerCase() !== 'ethiopia').length;
// //     const localCount = totalInvestors - fdiCount;
    
// //     // FIXED: Use normalizeCurrency for consistent payment mode matching
// //     const totalCapitalUSD = filteredInvestors.filter(i => 
// //       normalizeCurrency(i.payment_mode) === "usd"
// //     ).reduce((sum, i) => sum + (i.capital || 0), 0);
    
// //     const totalCapitalETB = filteredInvestors.filter(i => 
// //       normalizeCurrency(i.payment_mode) === "etb"
// //     ).reduce((sum, i) => sum + (i.capital || 0), 0);
    
// //     // Contract metrics
// //     const totalContracts = filteredContracts.length;
// //     const activeContracts = filteredContracts.filter(c => c.status === "Active").length;
    
// //     return {
// //       totalRevenueUSD, totalRevenueETB, totalOutstandingUSD, totalOutstandingETB, collectionRate,
// //       totalLaborFemale, totalLaborMale, totalProfFemale, totalProfMale, totalEmployees,
// //       totalExport, totalImport, totalImportSubstitution, totalLinkage, netTradeBalance,
// //       totalInvestors, fdiCount, localCount, totalCapitalUSD, totalCapitalETB,
// //       totalContracts, activeContracts
// //     };
// //   }, [filterByParkAndYear, revenueData, arrearsData, employmentData, tradeData, investorsData, contractsData]);

// //   // Chart Data
// //   const chartData = useMemo(() => {
// //     const mostRecentYear = getMostRecentYear();
    
// //     // Revenue by Park
// //     const revenueByPark = {};
// //     filterByParkAndYear(revenueData).forEach(r => {
// //       const park = r.park_name;
// //       if (park && park !== "N/A") {
// //         revenueByPark[park] = (revenueByPark[park] || 0) + (r.amount || 0);
// //       }
// //     });
    
// //     // Outstanding by Park
// //     const outstandingByPark = {};
// //     filterByParkAndYear(arrearsData).forEach(a => {
// //       const park = a.park_name;
// //       if (park && park !== "N/A") {
// //         outstandingByPark[park] = (outstandingByPark[park] || 0) + (a.outstanding || 0);
// //       }
// //     });
    
// //     // Monthly Revenue Trend for the most recent year (USD only)
// //     const monthlyRevenue = {
// //       "Jan": 0, "Feb": 0, "Mar": 0, "Apr": 0, "May": 0, "Jun": 0,
// //       "Jul": 0, "Aug": 0, "Sep": 0, "Oct": 0, "Nov": 0, "Dec": 0
// //     };
    
// //     revenueData
// //       .filter(r => normalizeCurrency(r.payment_mode) === "usd" && r.year === mostRecentYear)
// //       .forEach(r => {
// //         const monthNum = r.month?.padStart(2, '0');
// //         const monthName = monthNames[monthNum];
// //         if (monthName && monthlyRevenue[monthName] !== undefined) {
// //           monthlyRevenue[monthName] += (r.amount || 0);
// //         }
// //       });
    
// //     // Employment by Park (Gender)
// //     const employmentByPark = {};
// //     filterByParkAndYear(employmentData).forEach(e => {
// //       const park = e.park_name;
// //       if (park && park !== "N/A") {
// //         if (!employmentByPark[park]) employmentByPark[park] = { female: 0, male: 0 };
// //         employmentByPark[park].female += (e.emp_labor_female || 0) + (e.emp_prof_female || 0);
// //         employmentByPark[park].male += (e.emp_labor_male || 0) + (e.emp_prof_male || 0);
// //       }
// //     });
    
// //     // Investment Type Distribution
// //     // const investmentByType = {};
// //     // filterByParkAndYear(investorsData, 'year', 'park_name').forEach(i => {
// //     //   const type = i.investment_type;
// //     //   if (type && type !== "N/A") {
// //     //     investmentByType[type] = (investmentByType[type] || 0) + 1;
// //     //   }
// //     // });
// //     //********************************************* */
// // // ==================== REPLACE WITH THIS ====================
// // // Investment Type Distribution from active contracts only
// // const investmentByType = {};

// // // Get active contracts from contractsData
// // const activeContracts = contractsData.filter(c => c.status === 'active' || c.status === 'Active');

// // activeContracts.forEach(contract => {
// //   let type = contract.investment_type;
// //   if (type && type !== "N/A" && type !== "" && type !== "null" && type !== "undefined") {
// //     // Clean up the type name
// //     type = type.trim();
// //     investmentByType[type] = (investmentByType[type] || 0) + 1;
// //   }
// // });

// // // Add "Not Specified" category for active contracts without investment type
// // const notSpecifiedCount = activeContracts.filter(c => 
// //   !c.investment_type || c.investment_type === "N/A" || c.investment_type === "" || c.investment_type === "null"
// // ).length;

// // if (notSpecifiedCount > 0) {
// //   investmentByType["Not Specified"] = notSpecifiedCount;
// // }
// // // ==================== END OF REPLACED SECTION ====================
// //     // Export by Park (for horizontal bar chart)
// //     const exportByPark = {};
// //     filterByParkAndYear(tradeData).forEach(t => {
// //       const park = t.park_name;
// //       if (park && park !== "N/A") {
// //         exportByPark[park] = (exportByPark[park] || 0) + (t.export_amount || 0);
// //       }
// //     });
    
// //     // Trade Data by Park for Multi-Bar Chart
// //     console.log("Yearrrrrrr", mostRecentYear)
// //     const tradeByPark = {};
// //     tradeData
// //       .filter(t => t.year === mostRecentYear)
// //       .forEach(t => {
// //         const park = t.park_name;
// //         if (park && park !== "N/A") {
// //           if (!tradeByPark[park]) {
// //             tradeByPark[park] = { export: 0, import: 0, importSubstitution: 0 };
// //           }
// //           tradeByPark[park].export += (t.export_amount || 0);
// //           tradeByPark[park].import += (t.import_amount || 0);
// //           tradeByPark[park].importSubstitution += (t.import_substitution || 0);
// //         }
// //       });
    
// //     return { 
// //       revenueByPark, outstandingByPark, monthlyRevenue, employmentByPark, 
// //       investmentByType, exportByPark, tradeByPark, mostRecentYear 
// //     };
// //   }, [filterByParkAndYear, revenueData, arrearsData, employmentData, investorsData, tradeData, getMostRecentYear]);
// //  console.log("YAHHHHHHHHHHHHH", chartData.tradeByPark)
// //   if (loading) {
// //     return (
// //       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
// //         <CircularProgress />
// //         <Typography sx={{ ml: 2 }}>Loading dashboard data...</Typography>
// //       </Box>
// //     );
// //   }

// //   return (
// //     <Box sx={{ bgcolor: '#f4f9ff', width: '98%', mx: '1%', py: 1 }}>
// //       {/* Header */}
// //       <Box sx={{ color: 'white', py: 2, px: 3 }}>
// //         <Container maxWidth="xl">
// //           <Box>
// //             <Grid item xs={12} md={12}>
// //               <IPDCWelcomeMessage messageTitle="Operation Management" />
// //             </Grid>
// //           </Box>
// //         </Container>
// //       </Box>

// //       {/* KPI Summary Cards */}
// //       <Container maxWidth="xl" sx={{ mt: 2 }}>
// //         <Grid container spacing={1.5}>
// //           {/* Total Capital Card - First Row */}
// //           <Grid item xs={12} sm={6} md={2.4} sx={{ display: 'flex', justifyContent: 'center' }}>
// //   <Card sx={{ bgcolor: '#e3f2fd', boxShadow: 1, minHeight: '70px', width: '100%' }}>
// //     <CardContent sx={{  '&:last-child': { pb: 1 }, textAlign: 'center' }}>
// //       <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1rem' }}>
// //         Total Capital
// //       </Typography>
// //       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1.5, my: 0.5 }}>
// //         <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '0.9rem', color: '#1a237e' }}>
// //           USD: {formatCurrency(metrics.totalCapitalUSD)}
// //         </Typography>
// //         <Divider orientation="vertical" flexItem sx={{ height: 25, borderColor: '#999' }} />
// //         <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '0.9rem', color: '#1a237e' }}>
// //           ETB: {formatCurrencyETB(metrics.totalCapitalETB)}
// //         </Typography>
// //       </Box>
// //     </CardContent>
// //   </Card>
// // </Grid>

// //           {/* Export / Import Card */}
// //           <Grid item xs={6} sm={4} md={2.4}>
// //             <Card sx={{ p: 2, bgcolor: '#e3f2fd', height: '100%', minHeight: 120 }}>
// //               <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1rem', pl: 2 }}>Export / Import</Typography>
// //               <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '0.9rem', color: '#1a237e', pl: 2 }}>E: {formatCurrency(metrics.totalExport)}</Typography>
// //               <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#1a237e', pl: 2 }}>I: {formatCurrency(metrics.totalImport)} | Sub: {formatCurrency(metrics.totalImportSubstitution)}</Typography>
// //             </Card>
// //           </Grid>

// //           {/* Investors Card */}
// //           <Grid item xs={6} sm={4} md={2.4}>
// //             <Card sx={{ p: 2, bgcolor: '#e3f2fd', height: '100%', minHeight: 120 }}>
// //               <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1rem', pl: 2 }}>Investors</Typography>
// //               <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#7b1fa2', pl: 2 }}>{metrics.totalInvestors}</Typography>
// //               <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#1a237e', pl: 2 }}>FDI: {metrics.fdiCount} | Local: {metrics.localCount}</Typography>
// //             </Card>
// //           </Grid>

// //           {/* Total Employment Card */}
// //           <Grid item xs={6} sm={4} md={2.4}>
// //             <Card sx={{ p: 2, bgcolor: '#e3f2fd', height: '100%', minHeight: 120 }}>
// //               <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1rem', pl: 2 }}>Total Employment</Typography>
// //               <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#1a237e', pl: 2 }}>{formatNumber(metrics.totalEmployees)}</Typography>
// //               <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#1a237e', pl: 2 }}>♀ {formatNumber(metrics.totalLaborFemale + metrics.totalProfFemale)} | ♂ {formatNumber(metrics.totalLaborMale + metrics.totalProfMale)}</Typography>
// //             </Card>
// //           </Grid>

         

// //           {/* Outstanding Card */}
// //           <Grid item xs={6} sm={4} md={2.4}>
// //             <Card sx={{ p: 2, bgcolor: '#e3f2fd', height: '100%', minHeight: 120 }}>
// //               <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1rem', pl: 2 }}>Outstanding</Typography>
// //               <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#d32f2f', pl: 2 }}>USD: {formatCurrency(metrics.totalOutstandingUSD)}</Typography>
// //               <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#d32f2f', pl: 2 }}>ETB: {metrics.totalOutstandingETB}</Typography>
// //             </Card>
// //           </Grid>
// //         </Grid>
// //       </Container>

// //       {/* Charts Section */}
// //       <Container maxWidth="xl" sx={{ mt: 2, mb: 3 }}>
// //         {/* Row 1: Donut Charts */}
// //         <Grid container spacing={2} sx={{ mb: 2 }}>
// //           <Grid item xs={12} md={4}>
// //             <DonutChartComponent 
// //               title="Revenue Distribution by Park (USD)"
// //               data={chartData.revenueByPark}
// //               colors={['#1976d2', '#2e7d32', '#ed6c02', '#9c27b0', '#d32f2f', '#0288d1']}
// //               formatValue={formatCurrency}
// //               total={metrics.totalRevenueUSD}
// //             />
// //           </Grid>
// //           <Grid item xs={12} md={4}>
// //             <DonutChartComponent 
// //               title="Investment Type Distribution"
// //               data={chartData.investmentByType}
// //               // colors={['#1976d2', '#2e7d32', '#ed6c02']}
// //                  colors={[
// //                 '#1976d2', // Blue
// //                 '#2e7d32', // Green
// //                 '#ed6c02', // Orange
// //                 '#9c27b0', // Purple
// //                 '#d32f2f', // Red
// //                 '#0288d1', // Light Blue
// //                 '#7b1fa2', // Dark Purple
// //                 '#e65100', // Dark Orange
// //                 '#c2185b', // Pink
// //                 '#00695c', // Teal
// //                 '#f44336', // Red
// //                 '#4caf50'  // Light Green
// //               ]}
// //               formatValue={formatNumber}
// //               total={metrics.totalInvestors}
// //             />
// //           </Grid>
// //           <Grid item xs={12} md={4}>
// //             <HorizontalBarChart 
// //               title="Outstanding Receivables by Park (USD)"
// //               data={Object.fromEntries(Object.entries(chartData.outstandingByPark).map(([k, v]) => [k, { value: v }]))}
// //               dataKey="value"
// //               color="#d32f2f"
// //               formatValue={formatCurrency}
// //             />
// //           </Grid>
// //         </Grid>
// //       <Grid container spacing={2} sx={{ mb: 2 }}>
// //           <Grid item xs={12} md={6}>
// //             <TradeMultiBarChart 
// //               title="Trade Activity by Park"
// //               data={chartData.tradeByPark}
// //               formatValue={formatCurrency}
// //               recentYear={chartData.mostRecentYear}
// //             />
// //           </Grid>
// //           <Grid item xs={12} md={6}>
// //             <StackedBarChartComponent 
// //               title="Employment Distribution by Park (Gender)"
// //               data={chartData.employmentByPark}
// //               formatValue={formatNumber}
// //             />
// //           </Grid>
// //         </Grid>
// //         {/* Row 2: Horizontal Bar Charts */}
// //         <Grid container spacing={2} sx={{ mb: 2 }}>
          
// //           <Grid item xs={12} md={6}>
// //             <MonthlyLineChart 
// //               title={`Monthly Revenue Trend (${chartData.mostRecentYear} - USD)`}
// //               monthlyData={chartData.monthlyRevenue}
// //               formatValue={formatCurrency}
// //               color="#1976d2"
// //             />
// //           </Grid>
// //           <Grid item xs={12} md={6}>
// //             <HorizontalBarChart 
// //               title="Export Performance by Park (USD)"
// //               data={Object.fromEntries(Object.entries(chartData.exportByPark).map(([k, v]) => [k, { value: v }]))}
// //               dataKey="value"
// //               color="#4caf50"
// //               formatValue={formatCurrency}
// //             />
// //           </Grid>
// //         </Grid>

// //         {/* Row 3: Trade Chart */}
        

// //         {/* Row 4: Capacity Analysis and Gap Analysis */}
        
// //       </Container>

// //       {/* Footer */}
// //       {/* <Box sx={{ bgcolor: '#1a237e', color: 'white', py: 1.5, textAlign: 'center' }}>
// //         <Typography variant="caption">© 2024 Investor Aftercare & Supervision Dashboard | All Rights Reserved</Typography>
// //       </Box> */}
// //     </Box>
// //   );
// // }
// //********************************************************************************************* */

// import { useEffect, useState, useMemo, useCallback } from "react";
// import { IPDCWelcomeMessage } from "../../../components";
// import {
//   Container,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Box,
//   Paper,
//   Button,
//   IconButton,
//   Avatar,
//   Divider,
//   LinearProgress,
//   Tooltip,
//   Chip,
//   TextField,
//   InputAdornment,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Select,
//   CircularProgress,
//   ToggleButton,
//   ToggleButtonGroup
// } from "@mui/material";
// import {
//   TrendingUp as TrendingUpIcon,
//   TrendingDown as TrendingDownIcon,
//   Business as BusinessIcon,
//   People as PeopleIcon,
//   AttachMoney as MoneyIcon,
//   Assessment as AssessmentIcon,
//   Receipt as ReceiptIcon,
//   AccountBalance as AccountBalanceIcon,
//   WarningAmber as WarningIcon,
//   Download as DownloadIcon,
//   Refresh as RefreshIcon,
//   ArrowUpward as ArrowUpwardIcon,
//   ArrowDownward as ArrowDownwardIcon,
//   Inventory as InventoryIcon,
//   Store as StoreIcon,
//   LocalShipping as ExportIcon,
//   AssignmentReturn as ImportIcon,
//   Link as LinkageIcon,
//   SwapHoriz as SubstitutionIcon,
//   Work as WorkIcon,
//   Female as FemaleIcon,
//   Male as MaleIcon,
//   LocationOn as LocationOnIcon,
//   CalendarToday as CalendarIcon,
//   PieChart as PieChartIcon,
//   BarChart as BarChartIcon,
//   ShowChart as ShowChartIcon,
//   Search as SearchIcon,
//   Clear as ClearIcon,
//   Description as DescriptionIcon,
//   DonutLarge as DonutIcon,
//   Timeline as TimelineIcon,
//   StackedBarChart as StackedBarIcon
// } from "@mui/icons-material";
// import { format } from "date-fns";
// import { GetDataFromApiWithParams } from "../../../services/api/ExecuteApiRequests";

// // ==================== HELPER FUNCTIONS ====================
// const toNumber = (value) => {
//   if (typeof value === 'number' && !isNaN(value)) return value;
//   if (typeof value === 'string') {
//     const num = parseFloat(value.replace(/,/g, ''));
//     return isNaN(num) ? 0 : num;
//   }
//   return 0;
// };

// const formatNumber = (number) => {
//   const num = toNumber(number);
//   if (num === 0) return "0";
//   return new Intl.NumberFormat('en-US').format(num);
// };

// const formatCurrency = (amount) => {
//   if (!amount && amount !== 0) return "$0";
//   return new Intl.NumberFormat('en-US', {
//     style: 'currency',
//     currency: 'USD',
//     minimumFractionDigits: 0,
//     maximumFractionDigits: 0,
//   }).format(amount);
// };

// const formatCurrencyETB = (amount) => {
//   if (!amount && amount !== 0) return "Br0";
//   return `${formatNumber(amount)}`;
// };

// const normalizeCurrency = (paymentMode) => {
//   if (!paymentMode) return "unknown";
//   const mode = paymentMode.toLowerCase();
//   if (mode === "usd") return "usd";
//   if (mode === "birr" || mode === "etb") return "etb";
//   return mode;
// };

// // Month names mapping
// const monthNames = {
//   "01": "Jan", "02": "Feb", "03": "Mar", "04": "Apr", "05": "May", "06": "Jun",
//   "07": "Jul", "08": "Aug", "09": "Sep", "10": "Oct", "11": "Nov", "12": "Dec"
// };

// // ==================== DONUT CHART COMPONENT ====================
// const DonutChartComponent = ({ title, data, colors, formatValue, total }) => {
//   const items = Object.keys(data);
//   const totalValue = total || items.reduce((sum, key) => sum + (data[key] || 0), 0);
//   const donutColors = colors || [
//     '#005F73', '#0A9396', '#94D2BD', '#E9D8A6', '#EE9B00', '#CA6702', '#BB3E03', '#AE2012', '#9B2226', '#2D6A4F',
//     '#40916C', '#52B788', '#74C69D', '#1B4332', '#081C15', '#3F37C9', '#4361EE', '#4895EF', '#4CC9F0', '#7209B7',
//     '#B5179E', '#F72585', '#4A4E69', '#9A8C98', '#C9ADA7'
//   ];
  
//   if (items.length === 0 || totalValue === 0) {
//     return (
//       <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#fafafa', borderRadius: 2, height: '100%' }}>
//         <Typography variant="body2" color="textSecondary">No data available</Typography>
//       </Box>
//     );
//   }
  
//   let startAngle = 0;
//   const centerX = 80, centerY = 80, radius = 55;
//   const svgSize = 180;
  
//   return (
//     <Box sx={{ p: 0.5, bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
//       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1, fontSize: '1rem' }}>{title}</Typography>
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
//         <Box sx={{ position: 'relative', width: svgSize, height: svgSize }}>
//           <svg width={svgSize} height={svgSize} viewBox={`0 0 ${svgSize} ${svgSize}`}>
//             {items.map((key, index) => {
//               const value = data[key] || 0;
//               const percentage = totalValue > 0 ? (value / totalValue) * 100 : 0;
//               const angle = (percentage / 100) * 360;
//               const endAngle = startAngle + angle;
              
//               const startRad = (startAngle * Math.PI) / 180;
//               const endRad = (endAngle * Math.PI) / 180;
              
//               const x1 = centerX + radius * Math.cos(startRad);
//               const y1 = centerY + radius * Math.sin(startRad);
//               const x2 = centerX + radius * Math.cos(endRad);
//               const y2 = centerY + radius * Math.sin(endRad);
              
//               const largeArcFlag = angle > 180 ? 1 : 0;
//               const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
              
//               const slice = <path key={key} d={pathData} fill={donutColors[index % donutColors.length]} stroke="white" strokeWidth="2" />;
//               startAngle = endAngle;
//               return slice;
//             })}
//             <circle cx={centerX} cy={centerY} r="32" fill="white" />
//             <text x={centerX} y={centerY - 5} textAnchor="middle" fontSize="7" fill="#666">Total</text>
//             <text x={centerX} y={centerY + 8} textAnchor="middle" fontSize="8" fontWeight="bold" fill="#1976d2">{formatValue(totalValue)}</text>
//           </svg>
//         </Box>
//         <Box sx={{ minWidth: 120, maxHeight: 160, overflowY: 'auto' }}>
//           {items.slice(0, 5).map((key, index) => {
//             const value = data[key] || 0;
//             const percentage = totalValue > 0 ? ((value / totalValue) * 100).toFixed(1) : 0;
//             return (
//               <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 0.5 }}>
//                 <Box sx={{ width: 10, height: 10, bgcolor: donutColors[index % donutColors.length], borderRadius: 1 }} />
//                 <Typography variant="caption" sx={{ fontSize: '0.8rem', flex: 1 }}>{key.length > 15 ? key.substring(0, 12) + '...' : key}</Typography>
//                 <Typography variant="caption" sx={{ fontSize: '0.8rem' }}>{formatValue(value)} ({percentage}%)</Typography>
//               </Box>
//             );
//           })}
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// // ==================== HORIZONTAL BAR CHART ====================
// const HorizontalBarChart = ({ title, data, dataKey, color, formatValue }) => {
//   const items = Object.keys(data);
//   const maxValue = Math.max(...Object.values(data).map(d => d[dataKey] || 0), 0);
  
//   if (items.length === 0 || maxValue === 0) {
//     return (
//       <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
//         <Typography variant="body2" color="textSecondary">No data available</Typography>
//       </Box>
//     );
//   }
  
//   return (
//     <Box sx={{ p: 1.5, bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
//       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1.5, fontSize: '1rem' }}>{title}</Typography>
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//         {items.slice(0, 6).map((item) => {
//           const value = data[item][dataKey] || 0;
//           const percentage = maxValue > 0 ? (value / maxValue) * 100 : 0;
          
//           return (
//             <Box key={item}>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
//                 <Typography variant="caption" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>{item.length > 15 ? item.substring(0, 12) + '...' : item}</Typography>
//                 <Typography variant="caption" sx={{ fontSize: '0.8rem', fontWeight: 'bold', color: color }}>{formatValue(value)}</Typography>
//               </Box>
//               <LinearProgress
//                 variant="determinate"
//                 value={percentage}
//                 sx={{
//                   height: 8,
//                   borderRadius: 4,
//                   backgroundColor: '#e0e0e0',
//                   '& .MuiLinearProgress-bar': { backgroundColor: color, borderRadius: 4 }
//                 }}
//               />
//             </Box>
//           );
//         })}
//       </Box>
//     </Box>
//   );
// };

// // ==================== MONTHLY LINE CHART COMPONENT ====================
// const MonthlyLineChart = ({ title, monthlyData, formatValue, color }) => {
//   const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//   const values = months.map(month => monthlyData[month] || 0);
//   const maxValue = Math.max(...values, 1);
  
//   if (maxValue === 0) {
//     return (
//       <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#e3f2fd', borderRadius: 2, height: '100%' }}>
//         <Typography variant="body2" color="textSecondary">No monthly data available</Typography>
//       </Box>
//     );
//   }
  
//   const chartHeight = 200;
//   const chartWidth = 500;
//   const padding = { top: 20, right: 30, bottom: 35, left: 50 };
  
//   return (
//     <Box sx={{ p: 1.5, bgcolor: '#e3f2fd', borderRadius: 2, height: '100%' }}>
//       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1, fontSize: '0.7rem' }}>{title}</Typography>
//       <svg width="100%" height={chartHeight} viewBox={`0 0 ${chartWidth} ${chartHeight}`} preserveAspectRatio="xMidYMid meet">
//         {[0, 25, 50, 75, 100].map((percent) => {
//           const y = chartHeight - padding.bottom - (percent / 100) * (chartHeight - padding.top - padding.bottom);
//           const value = (maxValue * percent) / 100;
//           return (
//             <g key={percent}>
//               <line x1={padding.left} y1={y} x2={chartWidth - padding.right} y2={y} stroke="#e0e0e0" strokeWidth="0.8" strokeDasharray="3" />
//               <text x={padding.left - 8} y={y} textAnchor="end" fontSize="7" fill="#666">{formatValue(value)}</text>
//             </g>
//           );
//         })}
        
//         <polygon
//           points={`${padding.left},${chartHeight - padding.bottom} ${months.map((month, idx) => {
//             const x = padding.left + (idx / (months.length - 1)) * (chartWidth - padding.left - padding.right);
//             const value = monthlyData[month] || 0;
//             const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
//             return `${x},${y}`;
//           }).join(' ')} ${chartWidth - padding.right},${chartHeight - padding.bottom}`}
//           fill={`${color}20`}
//         />
        
//         <polyline
//           points={months.map((month, idx) => {
//             const x = padding.left + (idx / (months.length - 1)) * (chartWidth - padding.left - padding.right);
//             const value = monthlyData[month] || 0;
//             const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
//             return `${x},${y}`;
//           }).join(' ')}
//           fill="none"
//           stroke={color}
//           strokeWidth="2.5"
//         />
        
//         {months.map((month, idx) => {
//           const x = padding.left + (idx / (months.length - 1)) * (chartWidth - padding.left - padding.right);
//           const value = monthlyData[month] || 0;
//           const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
//           return (
//             <g key={month}>
//               <circle cx={x} cy={y} r="4" fill={color} stroke="white" strokeWidth="2" />
//               {value > 0 && (
//                 <text x={x} y={y - 8} textAnchor="middle" fontSize="7" fill={color} fontWeight="bold">
//                   {formatValue(value)}
//                 </text>
//               )}
//             </g>
//           );
//         })}
        
//         {months.map((month, idx) => {
//           const x = padding.left + (idx / (months.length - 1)) * (chartWidth - padding.left - padding.right);
//           return (
//             <text key={month} x={x} y={chartHeight - padding.bottom + 15} textAnchor="middle" fontSize="7" fontWeight="500">{month}</text>
//           );
//         })}
        
//         <line x1={padding.left} y1={padding.top} x2={padding.left} y2={chartHeight - padding.bottom} stroke="#999" strokeWidth="1" />
//         <line x1={padding.left} y1={chartHeight - padding.bottom} x2={chartWidth - padding.right} y2={chartHeight - padding.bottom} stroke="#999" strokeWidth="1" />
//       </svg>
//     </Box>
//   );
// };

// // ==================== TRADE MULTI-BAR CHART COMPONENT ====================
// const TradeMultiBarChart = ({ title, data, formatValue, recentYear }) => {
//   const parks = Object.keys(data);
//   const maxValue = Math.max(...Object.values(data).map(d => 
//     Math.max(d.export || 0, d.import || 0, d.importSubstitution || 0)
//   ), 0);
  
//   if (parks.length === 0 || maxValue === 0) {
//     return (
//       <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#e3f2fd', borderRadius: 2, height: '100%' }}>
//         <Typography variant="body2" color="textSecondary">No trade data available</Typography>
//       </Box>
//     );
//   }
  
//   return (
//     <Box sx={{ p: 1.5, bgcolor: '#e3f2fd', borderRadius: 2, height: '100%' }}>
//       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1.5, fontSize: '0.7rem' }}>
//         {title} ({recentYear})
//       </Typography>
//       <Box sx={{ overflowX: 'auto' }}>
//         <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, minHeight: 350, justifyContent: 'center', flexWrap: 'wrap', minWidth: 500 }}>
//           {parks.slice(0, 6).map((park) => {
//             const exportValue = data[park]?.export || 0;
//             const importValue = data[park]?.import || 0;
//             const importSubValue = data[park]?.importSubstitution || 0;
            
//             const heightExport = maxValue > 0 ? (exportValue / maxValue) * 200 : 0;
//             const heightImport = maxValue > 0 ? (importValue / maxValue) * 200 : 0;
//             const heightImportSub = maxValue > 0 ? (importSubValue / maxValue) * 200 : 0;
            
//             return (
//               <Tooltip 
//                 key={park} 
//                 title={
//                   <Box>
//                     <Typography variant="subtitle2">{park}</Typography>
//                     <Typography variant="body2">Export: {formatValue(exportValue)}</Typography>
//                     <Typography variant="body2">Import: {formatValue(importValue)}</Typography>
//                     <Typography variant="body2">Import Substitution: {formatValue(importSubValue)}</Typography>
//                   </Box>
//                 } 
//                 arrow 
//                 placement="top"
//               >
//                 <Box sx={{ textAlign: 'center', minWidth: 80 }}>
//                   <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center', alignItems: 'flex-end', height: 220 }}>
//                     <Box sx={{ position: 'relative', height: heightExport, width: '28px', bgcolor: '#4caf50', borderRadius: '3px 3px 0 0', transition: 'all 0.3s ease', '&:hover': { opacity: 0.8 } }}>
//                       {heightExport > 25 && (
//                         <Typography variant="caption" sx={{ position: 'absolute', bottom: heightExport - 18, left: '50%', transform: 'translateX(-50%)', fontSize: '7px', fontWeight: 'bold', color: 'white', whiteSpace: 'nowrap' }}>
//                           {formatValue(exportValue)}
//                         </Typography>
//                       )}
//                     </Box>
//                     <Box sx={{ position: 'relative', height: heightImport, width: '28px', bgcolor: '#ff9800', borderRadius: '3px 3px 0 0', transition: 'all 0.3s ease', '&:hover': { opacity: 0.8 } }}>
//                       {heightImport > 25 && (
//                         <Typography variant="caption" sx={{ position: 'absolute', bottom: heightImport - 18, left: '50%', transform: 'translateX(-50%)', fontSize: '7px', fontWeight: 'bold', color: 'white', whiteSpace: 'nowrap' }}>
//                           {formatValue(importValue)}
//                         </Typography>
//                       )}
//                     </Box>
//                     <Box sx={{ position: 'relative', height: heightImportSub, width: '28px', bgcolor: '#9c27b0', borderRadius: '3px 3px 0 0', transition: 'all 0.3s ease', '&:hover': { opacity: 0.8 } }}>
//                       {heightImportSub > 25 && (
//                         <Typography variant="caption" sx={{ position: 'absolute', bottom: heightImportSub - 18, left: '50%', transform: 'translateX(-50%)', fontSize: '7px', fontWeight: 'bold', color: 'white', whiteSpace: 'nowrap' }}>
//                           {formatValue(importSubValue)}
//                         </Typography>
//                       )}
//                     </Box>
//                   </Box>
//                   <Typography variant="caption" sx={{ mt: 0.5, display: 'block', fontWeight: 'bold', fontSize: '0.6rem' }}>
//                     {park.length > 12 ? park.substring(0, 10) + '...' : park}
//                   </Typography>
//                 </Box>
//               </Tooltip>
//             );
//           })}
//         </Box>
//       </Box>
//       <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mt: 2 }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//           <Box sx={{ width: 16, height: 16, bgcolor: '#4caf50', borderRadius: 1 }} />
//           <Typography variant="caption" sx={{ fontSize: '0.6rem' }}>Export</Typography>
//         </Box>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//           <Box sx={{ width: 16, height: 16, bgcolor: '#ff9800', borderRadius: 1 }} />
//           <Typography variant="caption" sx={{ fontSize: '0.6rem' }}>Import</Typography>
//         </Box>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//           <Box sx={{ width: 16, height: 16, bgcolor: '#9c27b0', borderRadius: 1 }} />
//           <Typography variant="caption" sx={{ fontSize: '0.6rem' }}>Import Substitution</Typography>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// // ==================== STACKED BAR CHART ====================
// const StackedBarChartComponent = ({ title, data, formatValue }) => {
//   const items = Object.keys(data);
//   const maxValue = Math.max(...Object.values(data).map(d => (d.female || 0) + (d.male || 0)), 0);
  
//   if (items.length === 0 || maxValue === 0) {
//     return (
//       <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
//         <Typography variant="body2" color="textSecondary">No employment data available</Typography>
//       </Box>
//     );
//   }
  
//   return (
//     <Box sx={{ p: 1.5, bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
//       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1.5, fontSize: '0.9rem' }}>{title}</Typography>
//       <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1, minHeight: 220, justifyContent: 'center', flexWrap: 'wrap' }}>
//         {items.slice(0, 5).map((item) => {
//           const femaleValue = data[item]?.female || 0;
//           const maleValue = data[item]?.male || 0;
//           const totalValue = femaleValue + maleValue;
//           const heightFemale = maxValue > 0 ? (femaleValue / maxValue) * 150 : 0;
//           const heightMale = maxValue > 0 ? (maleValue / maxValue) * 150 : 0;
          
//           return (
//             <Tooltip key={item} title={`${item}: Female ${formatValue(femaleValue)}, Male ${formatValue(maleValue)}`} arrow placement="top">
//               <Box sx={{ textAlign: 'center', minWidth: 60 }}>
//                 <Box sx={{ display: 'flex', gap: 0.3, justifyContent: 'center', alignItems: 'flex-end' }}>
//                   <Box sx={{ height: heightFemale, width: '22px', bgcolor: '#e91e63', borderRadius: '2px 2px 0 0' }} />
//                   <Box sx={{ height: heightMale, width: '22px', bgcolor: '#2196f3', borderRadius: '2px 2px 0 0' }} />
//                 </Box>
//                 <Typography variant="caption" sx={{ mt: 0.5, display: 'block', fontWeight: 'bold', fontSize: '0.8rem' }}>{item.length > 10 ? item.substring(0, 8) + '...' : item}</Typography>
//                 <Typography variant="caption" sx={{ fontSize: '0.8rem', color: '#666' }}>Total: {formatValue(totalValue)}</Typography>
//               </Box>
//             </Tooltip>
//           );
//         })}
//       </Box>
//       <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 1 }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}><Box sx={{ width: 12, height: 12, bgcolor: '#e91e63', borderRadius: 1 }} /><Typography variant="caption" sx={{ fontSize: '0.6rem' }}>Female</Typography></Box>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}><Box sx={{ width: 12, height: 12, bgcolor: '#2196f3', borderRadius: 1 }} /><Typography variant="caption" sx={{ fontSize: '0.6rem' }}>Male</Typography></Box>
//       </Box>
//     </Box>
//   );
// };

// // ==================== MAIN DASHBOARD ====================
// export default function InvestorAftercareDashboard() {
//   const [loading, setLoading] = useState(true);
//   const [currentTime, setCurrentTime] = useState(new Date());
  
//   // Data States
//   const [revenueData, setRevenueData] = useState([]);
//   const [arrearsData, setArrearsData] = useState([]);
//   const [employmentData, setEmploymentData] = useState([]);
//   const [tradeData, setTradeData] = useState([]);
//   const [contractsData, setContractsData] = useState([]);
//   const [investorsData, setInvestorsData] = useState([]);
  
//   // Filter States
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedPark, setSelectedPark] = useState("all");
//   const [parksList, setParksList] = useState(["all"]);
//   const [selectedYear, setSelectedYear] = useState("all");
//   const [yearsList, setYearsList] = useState(["all"]);

//   // Update time
//   useEffect(() => {
//     const timer = setInterval(() => setCurrentTime(new Date()), 60000);
//     return () => clearInterval(timer);
//   }, []);

//   // Fetch Revenue Data
//   useEffect(() => {
//     const fetchRevenue = async () => {
//       try {
//         const resultData = await GetDataFromApiWithParams(`finances/revenuereport`);
//         let dataArray = [];
//         if (resultData && Array.isArray(resultData)) dataArray = resultData;
//         else if (resultData?.data && Array.isArray(resultData.data)) dataArray = resultData.data;
//         else if (resultData?.results && Array.isArray(resultData.results)) dataArray = resultData.results;
//         console.log("KOKOKOKOKKOK",resultData)
//         // console.log("KOKOKOKOKKOK",resultData.map(item=>item.payment_date))
//         const formattedData = dataArray.map((item, index) => ({
//           id: item.id || index,
//           company_name: item.company_name || item.tenant_name || "N/A",
//           park_name: item.park_name || item.park || "N/A",
//           payment_mode: item.payment_mode || "USD",
//           amount: parseFloat(item.amount) || parseFloat(item.payment_amount) || 0,
//           month: item.month || (item.transaction_date ? format(new Date(item.transaction_date), 'MM') : "01"),
//           year: new Date(item.payment_date).getFullYear() || (item.transaction_date ? format(new Date(item.transaction_date), 'yyyy') : "2026")
//         }));
//         setRevenueData(formattedData);
//       } catch (error) {
//         console.error("Failed to fetch revenue data:", error);
//       }
//     };
//     fetchRevenue();
//   }, []);

//   // Fetch Arrear Data
//   useEffect(() => {
//     const fetchArrear = async () => {
//       try {
//         const resultData = await GetDataFromApiWithParams(`finances/arrearreport`);
//         let dataArray = [];
//         if (resultData && Array.isArray(resultData)) dataArray = resultData;
//         else if (resultData?.data && Array.isArray(resultData.data)) dataArray = resultData.data;
       
//         const formattedData = resultData.map(item => ({
//           id: item.agreement_id,
//           company_name: item.company_name || "N/A",
//           park_name: item.park_name || item.park || "N/A",
//           payment_mode: item.payment_mode || "USD",
//           outstanding: parseFloat(item.outstanding) || 0,
//           overdue_days: item.overdue_date || 0,
//           month: item.month || "01",
//           year: item.payment_date || "2026"
//         }));
//         setArrearsData(formattedData);
//       } catch (error) {
//         console.error("Failed to fetch arrears data:", error);
//       }
//     };
//     fetchArrear();
//   }, []);

//   // Fetch Employment Data - Modified
//   useEffect(() => {
//     const fetchEmployment = async () => {
//       try {
//         // Fetch from both endpoints
//         const [activityResult, employmentResult] = await Promise.all([
//           GetDataFromApiWithParams(`investors/getemployment`),
//           GetDataFromApiWithParams(`investors/getparkemployment`) // New endpoint for park_employment
//         ]);
        
//         let activityData = [];
//         let parkEmploymentData = [];
        
//         if (activityResult && Array.isArray(activityResult)) activityData = activityResult;
//         else if (activityResult?.data && Array.isArray(activityResult.data)) activityData = activityResult.data;
        
//         if (employmentResult && Array.isArray(employmentResult)) parkEmploymentData = employmentResult;
//         else if (employmentResult?.data && Array.isArray(employmentResult.data)) parkEmploymentData = employmentResult.data;
        
//         // Combine the data
//         const combinedMap = new Map();
        
//         // Add investor_activity data (created employment)
//         activityData.forEach(item => {
//           const key = item.investor_id || item.id;
//           if (!combinedMap.has(key)) {
//             combinedMap.set(key, {
//               id: item.id || key,
//               investor_id: key,
//               company_name: item.company_name || `Company ${key}`,
//               park_name: item.park_name || "N/A",
//               emp_labor_female: 0,
//               emp_labor_male: 0,
//               emp_prof_female: 0,
//               emp_prof_male: 0,
//               year: item.year || "2024",
//               month: item.month || "01"
//             });
//           }
//           const existing = combinedMap.get(key);
//           existing.emp_labor_female += parseInt(item.emp_labor_female) || 0;
//           existing.emp_labor_male += parseInt(item.emp_labor_male) || 0;
//           existing.emp_prof_female += parseInt(item.emp_prof_female) || 0;
//           existing.emp_prof_male += parseInt(item.emp_prof_male) || 0;
//         });
        
//         // Add park_employment data (present employment)
//         parkEmploymentData.forEach(item => {
//           const key = item.investor_id || item.id;
//           if (!combinedMap.has(key)) {
//             combinedMap.set(key, {
//               id: item.id || key,
//               investor_id: key,
//               company_name: item.company_name || `Company ${key}`,
//               park_name: item.park_name || "N/A",
//               emp_labor_female: 0,
//               emp_labor_male: 0,
//               emp_prof_female: 0,
//               emp_prof_male: 0,
//               year: item.year || "2024",
//               month: item.month || "01"
//             });
//           }
//           const existing = combinedMap.get(key);
//           // Add present values
//           existing.emp_labor_female += parseInt(item.labor_female) || 0;
//           existing.emp_labor_male += parseInt(item.labor_male) || 0;
//           existing.emp_prof_female += parseInt(item.professional_female) || 0;
//           existing.emp_prof_male += parseInt(item.professional_male) || 0;
//         });
        
//         const combinedData = Array.from(combinedMap.values());
//         setEmploymentData(combinedData);
        
//       } catch (error) {
//         console.error("Failed to fetch employment data:", error);
//       }
//     };
//     fetchEmployment();
//   }, []);

//   // Fetch Trade Data
//   useEffect(() => {
//     const fetchTrade = async () => {
//       try {
//         const resultData = await GetDataFromApiWithParams(`investors/getemployment`);
//         let dataArray = [];
//         if (resultData && Array.isArray(resultData)) dataArray = resultData;
//         else if (resultData?.data && Array.isArray(resultData.data)) dataArray = resultData.data;
        
//         const formattedData = dataArray.map(item => ({
//           id: item.id,
//           investor_id: item.investor_id,
//           park_name: item.park_name || "N/A",
//           export_amount: parseFloat(String(item.export_amount || '0').replace(/[$,]/g, '')) || 0,
//           import_amount: parseFloat(String(item.import || '0').replace(/[$,]/g, '')) || 0,
//           linkage_amount: parseFloat(String(item.linkage_money || '0').replace(/[$,]/g, '')) || 0,
//           import_substitution: parseFloat(String(item.import_substitution || '0').replace(/[$,]/g, '')) || 0,
//           year: item.recorded_on ? new Date(item.recorded_on).getFullYear() : "2026"
//         }));
//         setTradeData(formattedData);
//       } catch (error) {
//         console.error("Failed to fetch trade data:", error);
//       }
//     };
//     fetchTrade();
//   }, []);

//   // Fetch Contracts and Investors Data - FIXED VERSION
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const investorData = await GetDataFromApiWithParams(`investors/getinverstor`);
//         const contractData = await GetDataFromApiWithParams(`agreements/allagreements`);
        
//         let investors = [];
//         let contracts = [];
        
//         if (Array.isArray(investorData)) investors = investorData;
//         else if (investorData?.data && Array.isArray(investorData.data)) investors = investorData.data;
        
//         if (Array.isArray(contractData)) contracts = contractData;
//         else if (contractData?.data && Array.isArray(contractData.data)) contracts = contractData.data;
        
//         // FIXED: Include payment_mode from contract for each investor
//         const transformedInvestors = investors.map(investor => {
//           // Find matching contract to get payment_mode
//           const matchingContract = contracts.find(c => 
//             c.tenant_id === investor.id || 
//             c.tenant_id === investor.investor_id ||
//             c.investor_id === investor.id ||
//             c.investor_id === investor.investor_id
//           );
          
//           return {
//             id: investor.id || investor.investor_id,
//             company_name: investor.company_name || "N/A",
//             park_name: investor.park_name || "N/A",
//             investment_type: investor.investment_type || "N/A",
//             nationality: investor.nationality_origin || "Ethiopia",
//             capital: parseFloat(investor.capital) || 0,
//             payment_mode: matchingContract?.payment_mode || investor.payment_mode || "USD" // KEY FIX
//           };
//         });
        
//         const transformedContracts = contracts.map(contract => ({
//           id: contract.id || contract.agreement_id,
//           company_name: contract.company_name || "N/A",
//           park_name: contract.park_name || contract.park || "N/A",
//           investment_type: contract.investment_type || "N/A",
//           status: contract.status || "Active",
//           monthly_rent: parseFloat(contract.monthly_rent) || 0,
//           ownership_type: contract.ownership_type || "Leased"
//         }));
        
//         setInvestorsData(transformedInvestors);
//         setContractsData(transformedContracts);
//       } catch (error) {
//         console.error("Failed to fetch data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, []);

//   // Generate unique parks and years
//   useEffect(() => {
//     const allParks = new Set();
//     [...revenueData, ...arrearsData, ...employmentData, ...tradeData, ...investorsData, ...contractsData].forEach(item => {
//       if (item.park_name && item.park_name !== "N/A") allParks.add(item.park_name);
//     });
//     setParksList(["all", ...Array.from(allParks).sort()]);
    
//     const allYears = new Set();
//     [...revenueData, ...arrearsData, ...employmentData, ...tradeData].forEach(item => {
//       if (item.year) allYears.add(item.year);
//     });
//     setYearsList(["all", ...Array.from(allYears).sort().reverse()]);
//   }, [revenueData, arrearsData, employmentData, tradeData, investorsData, contractsData]);

//   // Filter data by park and year
//   const filterByParkAndYear = useCallback((data, yearField = 'year', parkField = 'park_name') => {
//     return data.filter(item => {
//       const parkMatch = selectedPark === "all" || item[parkField] === selectedPark;
//       const yearMatch = selectedYear === "all" || item[yearField] === selectedYear;
//       const searchMatch = searchTerm === "" || 
//         item.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         item.park_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         item.investor_id?.toString().includes(searchTerm);
//       return parkMatch && yearMatch && searchMatch;
//     });
//   }, [selectedPark, selectedYear, searchTerm]);

//  console.log("REVENUUUUUUUUUUUeeeeeeeeee", revenueData)
//   const getMostRecentYear = useCallback(() => {
//     const years = [...new Set(revenueData.map(r => r.year).filter(y => y && y !== "N/A"))];
//     if (years.length === 0) return "2026";
//     return years.sort().reverse()[0];
//   }, [revenueData]);

//   // Calculate metrics
//   const metrics = useMemo(() => {
//     const filteredRevenue = filterByParkAndYear(revenueData);
//     const filteredArrears = filterByParkAndYear(arrearsData);
//     const filteredEmployment = filterByParkAndYear(employmentData);
//     const filteredTrade = tradeData;
//     const filteredInvestors = filterByParkAndYear(investorsData, 'year', 'park_name');
//     const filteredContracts = filterByParkAndYear(contractsData, 'year', 'park_name');
    
//     // Revenue metrics
//     const totalRevenueUSD = filteredRevenue.filter(r => normalizeCurrency(r.payment_mode) === "usd").reduce((sum, r) => sum + (r.amount || 0), 0);
//     const totalRevenueETB = filteredRevenue.filter(r => normalizeCurrency(r.payment_mode) === "etb").reduce((sum, r) => sum + (r.amount || 0), 0);
//     const totalOutstandingUSD = filteredArrears.filter(a => normalizeCurrency(a.payment_mode) === "usd").reduce((sum, a) => sum + (a.outstanding || 0), 0);
//     const totalOutstandingETB = filteredArrears.filter(a => normalizeCurrency(a.payment_mode) === "etb").reduce((sum, a) => sum + (a.outstanding || 0), 0);
//     const totalCollectedUSD = Math.max(0, totalRevenueUSD - totalOutstandingUSD);
//     const collectionRate = totalRevenueUSD > 0 ? (totalCollectedUSD / totalRevenueUSD) * 100 : 0;
    
//     // Employment metrics
//     const totalLaborFemale = filteredEmployment.reduce((sum, e) => sum + (e.emp_labor_female || 0), 0);
//     const totalLaborMale = filteredEmployment.reduce((sum, e) => sum + (e.emp_labor_male || 0), 0);
//     const totalProfFemale = filteredEmployment.reduce((sum, e) => sum + (e.emp_prof_female || 0), 0);
//     const totalProfMale = filteredEmployment.reduce((sum, e) => sum + (e.emp_prof_male || 0), 0);
//     const totalEmployees = totalLaborFemale + totalLaborMale + totalProfFemale + totalProfMale;
    
//     // Trade metrics
//     const totalExport = filteredTrade.reduce((sum, t) => sum + (t.export_amount || 0), 0);
//     const totalImport = filteredTrade.reduce((sum, t) => sum + (t.import_amount || 0), 0);
//     const totalImportSubstitution = filteredTrade.reduce((sum, t) => sum + (t.import_substitution || 0), 0);
//     const totalLinkage = filteredTrade.reduce((sum, t) => sum + (t.linkage_amount || 0), 0);
//     const netTradeBalance = totalExport - totalImport;
    
//     // Investor metrics - FIXED: Using normalizeCurrency for both USD and ETB
//     const totalInvestors = filteredInvestors.length;
//     const fdiCount = filteredInvestors.filter(i => i.nationality && i.nationality.toLowerCase() !== 'ethiopia').length;
//     const localCount = totalInvestors - fdiCount;
    
//     // FIXED: Use normalizeCurrency for consistent payment mode matching
//     const totalCapitalUSD = filteredInvestors.filter(i => 
//       normalizeCurrency(i.payment_mode) === "usd"
//     ).reduce((sum, i) => sum + (i.capital || 0), 0);
    
//     const totalCapitalETB = filteredInvestors.filter(i => 
//       normalizeCurrency(i.payment_mode) === "etb"
//     ).reduce((sum, i) => sum + (i.capital || 0), 0);
    
//     // Contract metrics
//     const totalContracts = filteredContracts.length;
//     const activeContracts = filteredContracts.filter(c => c.status === "Active").length;
    
//     return {
//       totalRevenueUSD, totalRevenueETB, totalOutstandingUSD, totalOutstandingETB, collectionRate,
//       totalLaborFemale, totalLaborMale, totalProfFemale, totalProfMale, totalEmployees,
//       totalExport, totalImport, totalImportSubstitution, totalLinkage, netTradeBalance,
//       totalInvestors, fdiCount, localCount, totalCapitalUSD, totalCapitalETB,
//       totalContracts, activeContracts
//     };
//   }, [filterByParkAndYear, revenueData, arrearsData, employmentData, tradeData, investorsData, contractsData]);

//   // Chart Data
//   const chartData = useMemo(() => {
//     const mostRecentYear = getMostRecentYear();
    
//     // Revenue by Park
//     const revenueByPark = {};
//     filterByParkAndYear(revenueData).forEach(r => {
//       const park = r.park_name;
//       if (park && park !== "N/A") {
//         revenueByPark[park] = (revenueByPark[park] || 0) + (r.amount || 0);
//       }
//     });
    
//     // Outstanding by Park
//     const outstandingByPark = {};
//     filterByParkAndYear(arrearsData).forEach(a => {
//       const park = a.park_name;
//       if (park && park !== "N/A") {
//         outstandingByPark[park] = (outstandingByPark[park] || 0) + (a.outstanding || 0);
//       }
//     });
    
//     // Monthly Revenue Trend for the most recent year (USD only)
//     const monthlyRevenue = {
//       "Jan": 0, "Feb": 0, "Mar": 0, "Apr": 0, "May": 0, "Jun": 0,
//       "Jul": 0, "Aug": 0, "Sep": 0, "Oct": 0, "Nov": 0, "Dec": 0
//     };
    
//     revenueData
//       .filter(r => normalizeCurrency(r.payment_mode) === "usd" && r.year === mostRecentYear)
//       .forEach(r => {
//         const monthNum = r.month?.padStart(2, '0');
//         const monthName = monthNames[monthNum];
//         if (monthName && monthlyRevenue[monthName] !== undefined) {
//           monthlyRevenue[monthName] += (r.amount || 0);
//         }
//       });
    
//     // Employment by Park (Gender)
//     const employmentByPark = {};
//     filterByParkAndYear(employmentData).forEach(e => {
//       const park = e.park_name;
//       if (park && park !== "N/A") {
//         if (!employmentByPark[park]) employmentByPark[park] = { female: 0, male: 0 };
//         employmentByPark[park].female += (e.emp_labor_female || 0) + (e.emp_prof_female || 0);
//         employmentByPark[park].male += (e.emp_labor_male || 0) + (e.emp_prof_male || 0);
//       }
//     });
    
//     // ==================== FIXED: Investment Type Distribution from active contracts only ====================
//     const investmentByType = {};
    
//     // Get active contracts from contractsData
//     const activeContracts = contractsData.filter(c => c.status === 'active' || c.status === 'Active');
    
//     activeContracts.forEach(contract => {
//       let type = contract.investment_type;
//       if (type && type !== "N/A" && type !== "" && type !== "null" && type !== "undefined") {
//         // Clean up the type name
//         type = type.trim();
//         investmentByType[type] = (investmentByType[type] || 0) + 1;
//       }
//     });
    
//     // Add "Not Specified" category for active contracts without investment type
//     const notSpecifiedCount = activeContracts.filter(c => 
//       !c.investment_type || c.investment_type === "N/A" || c.investment_type === "" || c.investment_type === "null"
//     ).length;
    
//     if (notSpecifiedCount > 0) {
//       investmentByType["Not Specified"] = notSpecifiedCount;
//     }
//     // ==================== END OF FIXED SECTION ====================
    
//     // Export by Park (for horizontal bar chart)
//     const exportByPark = {};
//     filterByParkAndYear(tradeData).forEach(t => {
//       const park = t.park_name;
//       if (park && park !== "N/A") {
//         exportByPark[park] = (exportByPark[park] || 0) + (t.export_amount || 0);
//       }
//     });
    
//     // Trade Data by Park for Multi-Bar Chart
//     console.log("Yearrrrrrr", mostRecentYear)
//     const tradeByPark = {};
//     tradeData
//       .filter(t => t.year === mostRecentYear)
//       .forEach(t => {
//         const park = t.park_name;
//         if (park && park !== "N/A") {
//           if (!tradeByPark[park]) {
//             tradeByPark[park] = { export: 0, import: 0, importSubstitution: 0 };
//           }
//           tradeByPark[park].export += (t.export_amount || 0);
//           tradeByPark[park].import += (t.import_amount || 0);
//           tradeByPark[park].importSubstitution += (t.import_substitution || 0);
//         }
//       });
    
//     return { 
//       revenueByPark, outstandingByPark, monthlyRevenue, employmentByPark, 
//       investmentByType, exportByPark, tradeByPark, mostRecentYear 
//     };
//   }, [filterByParkAndYear, revenueData, arrearsData, employmentData, investorsData, tradeData, getMostRecentYear, contractsData]); // ← ADDED contractsData HERE

//  console.log("YAHHHHHHHHHHHHH", chartData.tradeByPark)
//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <CircularProgress />
//         <Typography sx={{ ml: 2 }}>Loading dashboard data...</Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ bgcolor: '#f4f9ff', width: '98%', mx: '1%', py: 1 }}>
//       {/* Header */}
//       <Box sx={{ color: 'white', py: 2, px: 3 }}>
//         <Container maxWidth="xl">
//           <Box>
//             <Grid item xs={12} md={12}>
//               <IPDCWelcomeMessage messageTitle="Operation Management" />
//             </Grid>
//           </Box>
//         </Container>
//       </Box>

//       {/* KPI Summary Cards */}
//       <Container maxWidth="xl" sx={{ mt: 2 }}>
//         <Grid container spacing={1.5}>
//           {/* Total Capital Card - First Row */}
//           <Grid item xs={12} sm={6} md={2.4} sx={{ display: 'flex', justifyContent: 'center' }}>
//   <Card sx={{ bgcolor: '#e3f2fd', boxShadow: 1, minHeight: '70px', width: '100%' }}>
//     <CardContent sx={{  '&:last-child': { pb: 1 }, textAlign: 'center' }}>
//       <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1rem' }}>
//         Total Capital
//       </Typography>
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1.5, my: 0.5 }}>
//         <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '0.9rem', color: '#1a237e' }}>
//           USD: {formatCurrency(metrics.totalCapitalUSD)}
//         </Typography>
//         <Divider orientation="vertical" flexItem sx={{ height: 25, borderColor: '#999' }} />
//         <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '0.9rem', color: '#1a237e' }}>
//           ETB: {formatCurrencyETB(metrics.totalCapitalETB)}
//         </Typography>
//       </Box>
//     </CardContent>
//   </Card>
// </Grid>

//           {/* Export / Import Card */}
//           <Grid item xs={6} sm={4} md={2.4}>
//             <Card sx={{ p: 2, bgcolor: '#e3f2fd', height: '100%', minHeight: 120 }}>
//               <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1rem', pl: 2 }}>Export / Import</Typography>
//               <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '0.9rem', color: '#1a237e', pl: 2 }}>E: {formatCurrency(metrics.totalExport)}</Typography>
//               <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#1a237e', pl: 2 }}>I: {formatCurrency(metrics.totalImport)} | Sub: {formatCurrency(metrics.totalImportSubstitution)}</Typography>
//             </Card>
//           </Grid>

//           {/* Investors Card */}
//           <Grid item xs={6} sm={4} md={2.4}>
//             <Card sx={{ p: 2, bgcolor: '#e3f2fd', height: '100%', minHeight: 120 }}>
//               <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1rem', pl: 2 }}>Investors</Typography>
//               <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#7b1fa2', pl: 2 }}>{metrics.totalInvestors}</Typography>
//               <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#1a237e', pl: 2 }}>FDI: {metrics.fdiCount} | Local: {metrics.localCount}</Typography>
//             </Card>
//           </Grid>

//           {/* Total Employment Card */}
//           <Grid item xs={6} sm={4} md={2.4}>
//             <Card sx={{ p: 2, bgcolor: '#e3f2fd', height: '100%', minHeight: 120 }}>
//               <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1rem', pl: 2 }}>Total Employment</Typography>
//               <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#1a237e', pl: 2 }}>{formatNumber(metrics.totalEmployees)}</Typography>
//               <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#1a237e', pl: 2 }}>♀ {formatNumber(metrics.totalLaborFemale + metrics.totalProfFemale)} | ♂ {formatNumber(metrics.totalLaborMale + metrics.totalProfMale)}</Typography>
//             </Card>
//           </Grid>

         

//           {/* Outstanding Card */}
//           <Grid item xs={6} sm={4} md={2.4}>
//             <Card sx={{ p: 2, bgcolor: '#e3f2fd', height: '100%', minHeight: 120 }}>
//               <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1rem', pl: 2 }}>Outstanding</Typography>
//               <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#d32f2f', pl: 2 }}>USD: {formatCurrency(metrics.totalOutstandingUSD)}</Typography>
//               <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#d32f2f', pl: 2 }}>ETB: {metrics.totalOutstandingETB}</Typography>
//             </Card>
//           </Grid>
//         </Grid>
//       </Container>

//       {/* Charts Section */}
//       <Container maxWidth="xl" sx={{ mt: 2, mb: 3 }}>
//         {/* Row 1: Donut Charts */}
//         <Grid container spacing={2} sx={{ mb: 2 }}>
//           <Grid item xs={12} md={4}>
//             <DonutChartComponent 
//               title="Revenue Distribution by Park (USD)"
//               data={chartData.revenueByPark}
//               colors={['#1976d2', '#2e7d32', '#ed6c02', '#9c27b0', '#d32f2f', '#0288d1']}
//               formatValue={formatCurrency}
//               total={metrics.totalRevenueUSD}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <DonutChartComponent 
//               title="Investment Type Distribution"
//               data={chartData.investmentByType}
//               colors={[
//                 '#1976d2', // Blue
//                 '#2e7d32', // Green
//                 '#ed6c02', // Orange
//                 '#9c27b0', // Purple
//                 '#d32f2f', // Red
//                 '#0288d1', // Light Blue
//                 '#7b1fa2', // Dark Purple
//                 '#e65100', // Dark Orange
//                 '#c2185b', // Pink
//                 '#00695c', // Teal
//                 '#f44336', // Red
//                 '#4caf50'  // Light Green
//               ]}
//               formatValue={formatNumber}
//               total={Object.values(chartData.investmentByType).reduce((sum, count) => sum + count, 0)} // ← FIXED: Use sum of investment types
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <HorizontalBarChart 
//               title="Outstanding Receivables by Park (USD)"
//               data={Object.fromEntries(Object.entries(chartData.outstandingByPark).map(([k, v]) => [k, { value: v }]))}
//               dataKey="value"
//               color="#d32f2f"
//               formatValue={formatCurrency}
//             />
//           </Grid>
//         </Grid>
//       <Grid container spacing={2} sx={{ mb: 2 }}>
//           <Grid item xs={12} md={6}>
//             <TradeMultiBarChart 
//               title="Trade Activity by Park"
//               data={chartData.tradeByPark}
//               formatValue={formatCurrency}
//               recentYear={chartData.mostRecentYear}
//             />
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <StackedBarChartComponent 
//               title="Employment Distribution by Park (Gender)"
//               data={chartData.employmentByPark}
//               formatValue={formatNumber}
//             />
//           </Grid>
//         </Grid>
//         {/* Row 2: Horizontal Bar Charts */}
//         <Grid container spacing={2} sx={{ mb: 2 }}>
          
//           <Grid item xs={12} md={6}>
//             <MonthlyLineChart 
//               title={`Monthly Revenue Trend (${chartData.mostRecentYear} - USD)`}
//               monthlyData={chartData.monthlyRevenue}
//               formatValue={formatCurrency}
//               color="#1976d2"
//             />
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <HorizontalBarChart 
//               title="Export Performance by Park (USD)"
//               data={Object.fromEntries(Object.entries(chartData.exportByPark).map(([k, v]) => [k, { value: v }]))}
//               dataKey="value"
//               color="#4caf50"
//               formatValue={formatCurrency}
//             />
//           </Grid>
//         </Grid>

//         {/* Row 3: Trade Chart */}
        

//         {/* Row 4: Capacity Analysis and Gap Analysis */}
        
//       </Container>

//       {/* Footer */}
//       {/* <Box sx={{ bgcolor: '#1a237e', color: 'white', py: 1.5, textAlign: 'center' }}>
//         <Typography variant="caption">© 2024 Investor Aftercare & Supervision Dashboard | All Rights Reserved</Typography>
//       </Box> */}
//     </Box>
//   );
// }
//**************************************************************************** */

import { useEffect, useState, useMemo, useCallback } from "react";
import { IPDCWelcomeMessage } from "../../../components";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Paper,
  Button,
  IconButton,
  Avatar,
  Divider,
  LinearProgress,
  Tooltip,
  Chip,
  TextField,
  InputAdornment,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  CircularProgress,
  ToggleButton,
  ToggleButtonGroup
} from "@mui/material";
import {
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  Business as BusinessIcon,
  People as PeopleIcon,
  AttachMoney as MoneyIcon,
  Assessment as AssessmentIcon,
  Receipt as ReceiptIcon,
  AccountBalance as AccountBalanceIcon,
  WarningAmber as WarningIcon,
  Download as DownloadIcon,
  Refresh as RefreshIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  Inventory as InventoryIcon,
  Store as StoreIcon,
  LocalShipping as ExportIcon,
  AssignmentReturn as ImportIcon,
  Link as LinkageIcon,
  SwapHoriz as SubstitutionIcon,
  Work as WorkIcon,
  Female as FemaleIcon,
  Male as MaleIcon,
  LocationOn as LocationOnIcon,
  CalendarToday as CalendarIcon,
  PieChart as PieChartIcon,
  BarChart as BarChartIcon,
  ShowChart as ShowChartIcon,
  Search as SearchIcon,
  Clear as ClearIcon,
  Description as DescriptionIcon,
  DonutLarge as DonutIcon,
  Timeline as TimelineIcon,
  StackedBarChart as StackedBarIcon
} from "@mui/icons-material";
import { format } from "date-fns";
import { GetDataFromApiWithParams } from "../../../services/api/ExecuteApiRequests";

// ==================== HELPER FUNCTIONS ====================
const toNumber = (value) => {
  if (typeof value === 'number' && !isNaN(value)) return value;
  if (typeof value === 'string') {
    const num = parseFloat(value.replace(/,/g, ''));
    return isNaN(num) ? 0 : num;
  }
  return 0;
};

const formatNumber = (number) => {
  const num = toNumber(number);
  if (num === 0) return "0";
  return new Intl.NumberFormat('en-US').format(num);
};

const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return "$0";
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

const formatCurrencyETB = (amount) => {
  if (!amount && amount !== 0) return "Br0";
  return `${formatNumber(amount)}`;
};

const normalizeCurrency = (paymentMode) => {
  if (!paymentMode) return "unknown";
  const mode = paymentMode.toLowerCase();
  if (mode === "usd") return "usd";
  if (mode === "birr" || mode === "etb") return "etb";
  return mode;
};

// Month names mapping
const monthNames = {
  "01": "Jan", "02": "Feb", "03": "Mar", "04": "Apr", "05": "May", "06": "Jun",
  "07": "Jul", "08": "Aug", "09": "Sep", "10": "Oct", "11": "Nov", "12": "Dec"
};

// ==================== DONUT CHART COMPONENT ====================
const DonutChartComponent = ({ title, data, colors, formatValue, total }) => {
  const items = Object.keys(data);
  const totalValue = total || items.reduce((sum, key) => sum + (data[key] || 0), 0);
  const donutColors = colors || [
    '#005F73', '#0A9396', '#94D2BD', '#E9D8A6', '#EE9B00', '#CA6702', '#BB3E03', '#AE2012', '#9B2226', '#2D6A4F',
    '#40916C', '#52B788', '#74C69D', '#1B4332', '#081C15', '#3F37C9', '#4361EE', '#4895EF', '#4CC9F0', '#7209B7',
    '#B5179E', '#F72585', '#4A4E69', '#9A8C98', '#C9ADA7'
  ];
  
  if (items.length === 0 || totalValue === 0) {
    return (
      <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#fafafa', borderRadius: 2, height: '100%' }}>
        <Typography variant="body2" color="textSecondary">No data available</Typography>
      </Box>
    );
  }
  
  let startAngle = 0;
  const centerX = 80, centerY = 80, radius = 55;
  const svgSize = 180;
  
  return (
    <Box sx={{ p: 0.5, bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1, fontSize: '1rem' }}>{title}</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
        <Box sx={{ position: 'relative', width: svgSize, height: svgSize }}>
          <svg width={svgSize} height={svgSize} viewBox={`0 0 ${svgSize} ${svgSize}`}>
            {items.map((key, index) => {
              const value = data[key] || 0;
              const percentage = totalValue > 0 ? (value / totalValue) * 100 : 0;
              const angle = (percentage / 100) * 360;
              const endAngle = startAngle + angle;
              
              const startRad = (startAngle * Math.PI) / 180;
              const endRad = (endAngle * Math.PI) / 180;
              
              const x1 = centerX + radius * Math.cos(startRad);
              const y1 = centerY + radius * Math.sin(startRad);
              const x2 = centerX + radius * Math.cos(endRad);
              const y2 = centerY + radius * Math.sin(endRad);
              
              const largeArcFlag = angle > 180 ? 1 : 0;
              const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
              
              const slice = <path key={key} d={pathData} fill={donutColors[index % donutColors.length]} stroke="white" strokeWidth="2" />;
              startAngle = endAngle;
              return slice;
            })}
            <circle cx={centerX} cy={centerY} r="32" fill="white" />
            <text x={centerX} y={centerY - 5} textAnchor="middle" fontSize="7" fill="#666">Total</text>
            <text x={centerX} y={centerY + 8} textAnchor="middle" fontSize="8" fontWeight="bold" fill="#1976d2">{formatValue(totalValue)}</text>
          </svg>
        </Box>
        <Box sx={{ minWidth: 120, maxHeight: 160, overflowY: 'auto' }}>
          {items.slice(0, 5).map((key, index) => {
            const value = data[key] || 0;
            const percentage = totalValue > 0 ? ((value / totalValue) * 100).toFixed(1) : 0;
            return (
              <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 0.5 }}>
                <Box sx={{ width: 10, height: 10, bgcolor: donutColors[index % donutColors.length], borderRadius: 1 }} />
                <Typography variant="caption" sx={{ fontSize: '0.8rem', flex: 1 }}>{key.length > 15 ? key.substring(0, 12) + '...' : key}</Typography>
                <Typography variant="caption" sx={{ fontSize: '0.8rem' }}>{formatValue(value)} ({percentage}%)</Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

// ==================== HORIZONTAL BAR CHART ====================
const HorizontalBarChart = ({ title, data, dataKey, color, formatValue }) => {
  const items = Object.keys(data);
  const maxValue = Math.max(...Object.values(data).map(d => d[dataKey] || 0), 0);
  
  if (items.length === 0 || maxValue === 0) {
    return (
      <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
        <Typography variant="body2" color="textSecondary">No data available</Typography>
      </Box>
    );
  }
  
  return (
    <Box sx={{ p: 1.5, bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1.5, fontSize: '1rem' }}>{title}</Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {items.slice(0, 6).map((item) => {
          const value = data[item][dataKey] || 0;
          const percentage = maxValue > 0 ? (value / maxValue) * 100 : 0;
          
          return (
            <Box key={item}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
                <Typography variant="caption" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>{item.length > 15 ? item.substring(0, 12) + '...' : item}</Typography>
                <Typography variant="caption" sx={{ fontSize: '0.8rem', fontWeight: 'bold', color: color }}>{formatValue(value)}</Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={percentage}
                sx={{
                  height: 8,
                  borderRadius: 4,
                  backgroundColor: '#e0e0e0',
                  '& .MuiLinearProgress-bar': { backgroundColor: color, borderRadius: 4 }
                }}
              />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

// ==================== MONTHLY LINE CHART COMPONENT ====================
const MonthlyLineChart = ({ title, monthlyData, formatValue, color }) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const values = months.map(month => monthlyData[month] || 0);
  const maxValue = Math.max(...values, 1);
  
  if (maxValue === 0) {
    return (
      <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#e3f2fd', borderRadius: 2, height: '100%' }}>
        <Typography variant="body2" color="textSecondary">No monthly data available</Typography>
      </Box>
    );
  }
  
  const chartHeight = 200;
  const chartWidth = 500;
  const padding = { top: 20, right: 30, bottom: 35, left: 50 };
  
  return (
    <Box sx={{ p: 1.5, bgcolor: '#e3f2fd', borderRadius: 2, height: '100%' }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1, fontSize: '0.7rem' }}>{title}</Typography>
      <svg width="100%" height={chartHeight} viewBox={`0 0 ${chartWidth} ${chartHeight}`} preserveAspectRatio="xMidYMid meet">
        {[0, 25, 50, 75, 100].map((percent) => {
          const y = chartHeight - padding.bottom - (percent / 100) * (chartHeight - padding.top - padding.bottom);
          const value = (maxValue * percent) / 100;
          return (
            <g key={percent}>
              <line x1={padding.left} y1={y} x2={chartWidth - padding.right} y2={y} stroke="#e0e0e0" strokeWidth="0.8" strokeDasharray="3" />
              <text x={padding.left - 8} y={y} textAnchor="end" fontSize="7" fill="#666">{formatValue(value)}</text>
            </g>
          );
        })}
        
        <polygon
          points={`${padding.left},${chartHeight - padding.bottom} ${months.map((month, idx) => {
            const x = padding.left + (idx / (months.length - 1)) * (chartWidth - padding.left - padding.right);
            const value = monthlyData[month] || 0;
            const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
            return `${x},${y}`;
          }).join(' ')} ${chartWidth - padding.right},${chartHeight - padding.bottom}`}
          fill={`${color}20`}
        />
        
        <polyline
          points={months.map((month, idx) => {
            const x = padding.left + (idx / (months.length - 1)) * (chartWidth - padding.left - padding.right);
            const value = monthlyData[month] || 0;
            const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
            return `${x},${y}`;
          }).join(' ')}
          fill="none"
          stroke={color}
          strokeWidth="2.5"
        />
        
        {months.map((month, idx) => {
          const x = padding.left + (idx / (months.length - 1)) * (chartWidth - padding.left - padding.right);
          const value = monthlyData[month] || 0;
          const y = chartHeight - padding.bottom - (value / maxValue) * (chartHeight - padding.top - padding.bottom);
          return (
            <g key={month}>
              <circle cx={x} cy={y} r="4" fill={color} stroke="white" strokeWidth="2" />
              {value > 0 && (
                <text x={x} y={y - 8} textAnchor="middle" fontSize="7" fill={color} fontWeight="bold">
                  {formatValue(value)}
                </text>
              )}
            </g>
          );
        })}
        
        {months.map((month, idx) => {
          const x = padding.left + (idx / (months.length - 1)) * (chartWidth - padding.left - padding.right);
          return (
            <text key={month} x={x} y={chartHeight - padding.bottom + 15} textAnchor="middle" fontSize="7" fontWeight="500">{month}</text>
          );
        })}
        
        <line x1={padding.left} y1={padding.top} x2={padding.left} y2={chartHeight - padding.bottom} stroke="#999" strokeWidth="1" />
        <line x1={padding.left} y1={chartHeight - padding.bottom} x2={chartWidth - padding.right} y2={chartHeight - padding.bottom} stroke="#999" strokeWidth="1" />
      </svg>
    </Box>
  );
};

// ==================== TRADE MULTI-BAR CHART COMPONENT ====================
const TradeMultiBarChart = ({ title, data, formatValue, recentYear }) => {
  const parks = Object.keys(data);
  const maxValue = Math.max(...Object.values(data).map(d => 
    Math.max(d.export || 0, d.import || 0, d.importSubstitution || 0)
  ), 0);
  
  if (parks.length === 0 || maxValue === 0) {
    return (
      <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#e3f2fd', borderRadius: 2, height: '100%' }}>
        <Typography variant="body2" color="textSecondary">No trade data available</Typography>
      </Box>
    );
  }
  
  return (
    <Box sx={{ p: 1.5, bgcolor: '#e3f2fd', borderRadius: 2, height: '100%' }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1.5, fontSize: '0.7rem' }}>
        {title} ({recentYear})
      </Typography>
      <Box sx={{ overflowX: 'auto' }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, minHeight: 350, justifyContent: 'center', flexWrap: 'wrap', minWidth: 500 }}>
          {parks.slice(0, 6).map((park) => {
            const exportValue = data[park]?.export || 0;
            const importValue = data[park]?.import || 0;
            const importSubValue = data[park]?.importSubstitution || 0;
            
            const heightExport = maxValue > 0 ? (exportValue / maxValue) * 200 : 0;
            const heightImport = maxValue > 0 ? (importValue / maxValue) * 200 : 0;
            const heightImportSub = maxValue > 0 ? (importSubValue / maxValue) * 200 : 0;
            
            return (
              <Tooltip 
                key={park} 
                title={
                  <Box>
                    <Typography variant="subtitle2">{park}</Typography>
                    <Typography variant="body2">Export: {formatValue(exportValue)}</Typography>
                    <Typography variant="body2">Import: {formatValue(importValue)}</Typography>
                    <Typography variant="body2">Import Substitution: {formatValue(importSubValue)}</Typography>
                  </Box>
                } 
                arrow 
                placement="top"
              >
                <Box sx={{ textAlign: 'center', minWidth: 80 }}>
                  <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center', alignItems: 'flex-end', height: 220 }}>
                    <Box sx={{ position: 'relative', height: heightExport, width: '28px', bgcolor: '#4caf50', borderRadius: '3px 3px 0 0', transition: 'all 0.3s ease', '&:hover': { opacity: 0.8 } }}>
                      {heightExport > 25 && (
                        <Typography variant="caption" sx={{ position: 'absolute', bottom: heightExport - 18, left: '50%', transform: 'translateX(-50%)', fontSize: '7px', fontWeight: 'bold', color: 'white', whiteSpace: 'nowrap' }}>
                          {formatValue(exportValue)}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ position: 'relative', height: heightImport, width: '28px', bgcolor: '#ff9800', borderRadius: '3px 3px 0 0', transition: 'all 0.3s ease', '&:hover': { opacity: 0.8 } }}>
                      {heightImport > 25 && (
                        <Typography variant="caption" sx={{ position: 'absolute', bottom: heightImport - 18, left: '50%', transform: 'translateX(-50%)', fontSize: '7px', fontWeight: 'bold', color: 'white', whiteSpace: 'nowrap' }}>
                          {formatValue(importValue)}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ position: 'relative', height: heightImportSub, width: '28px', bgcolor: '#9c27b0', borderRadius: '3px 3px 0 0', transition: 'all 0.3s ease', '&:hover': { opacity: 0.8 } }}>
                      {heightImportSub > 25 && (
                        <Typography variant="caption" sx={{ position: 'absolute', bottom: heightImportSub - 18, left: '50%', transform: 'translateX(-50%)', fontSize: '7px', fontWeight: 'bold', color: 'white', whiteSpace: 'nowrap' }}>
                          {formatValue(importSubValue)}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Typography variant="caption" sx={{ mt: 0.5, display: 'block', fontWeight: 'bold', fontSize: '0.6rem' }}>
                    {park.length > 12 ? park.substring(0, 10) + '...' : park}
                  </Typography>
                </Box>
              </Tooltip>
            );
          })}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mt: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box sx={{ width: 16, height: 16, bgcolor: '#4caf50', borderRadius: 1 }} />
          <Typography variant="caption" sx={{ fontSize: '0.6rem' }}>Export</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box sx={{ width: 16, height: 16, bgcolor: '#ff9800', borderRadius: 1 }} />
          <Typography variant="caption" sx={{ fontSize: '0.6rem' }}>Import</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box sx={{ width: 16, height: 16, bgcolor: '#9c27b0', borderRadius: 1 }} />
          <Typography variant="caption" sx={{ fontSize: '0.6rem' }}>Import Substitution</Typography>
        </Box>
      </Box>
    </Box>
  );
};

// ==================== STACKED BAR CHART ====================
const StackedBarChartComponent = ({ title, data, formatValue }) => {
  const items = Object.keys(data);
  const maxValue = Math.max(...Object.values(data).map(d => (d.female || 0) + (d.male || 0)), 0);
  
  if (items.length === 0 || maxValue === 0) {
    return (
      <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
        <Typography variant="body2" color="textSecondary">No employment data available</Typography>
      </Box>
    );
  }
  
  return (
    <Box sx={{ p: 1.5, bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1.5, fontSize: '0.9rem' }}>{title}</Typography>
      <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1, minHeight: 220, justifyContent: 'center', flexWrap: 'wrap' }}>
        {items.slice(0, 5).map((item) => {
          const femaleValue = data[item]?.female || 0;
          const maleValue = data[item]?.male || 0;
          const totalValue = femaleValue + maleValue;
          const heightFemale = maxValue > 0 ? (femaleValue / maxValue) * 150 : 0;
          const heightMale = maxValue > 0 ? (maleValue / maxValue) * 150 : 0;
          
          return (
            <Tooltip key={item} title={`${item}: Female ${formatValue(femaleValue)}, Male ${formatValue(maleValue)}`} arrow placement="top">
              <Box sx={{ textAlign: 'center', minWidth: 60 }}>
                <Box sx={{ display: 'flex', gap: 0.3, justifyContent: 'center', alignItems: 'flex-end' }}>
                  <Box sx={{ height: heightFemale, width: '22px', bgcolor: '#e91e63', borderRadius: '2px 2px 0 0' }} />
                  <Box sx={{ height: heightMale, width: '22px', bgcolor: '#2196f3', borderRadius: '2px 2px 0 0' }} />
                </Box>
                <Typography variant="caption" sx={{ mt: 0.5, display: 'block', fontWeight: 'bold', fontSize: '0.8rem' }}>{item.length > 10 ? item.substring(0, 8) + '...' : item}</Typography>
                <Typography variant="caption" sx={{ fontSize: '0.8rem', color: '#666' }}>Total: {formatValue(totalValue)}</Typography>
              </Box>
            </Tooltip>
          );
        })}
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}><Box sx={{ width: 12, height: 12, bgcolor: '#e91e63', borderRadius: 1 }} /><Typography variant="caption" sx={{ fontSize: '0.6rem' }}>Female</Typography></Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}><Box sx={{ width: 12, height: 12, bgcolor: '#2196f3', borderRadius: 1 }} /><Typography variant="caption" sx={{ fontSize: '0.6rem' }}>Male</Typography></Box>
      </Box>
    </Box>
  );
};

// ==================== MAIN DASHBOARD ====================
export default function InvestorAftercareDashboard() {
  const [loading, setLoading] = useState(true);
  const [currentTime, setCurrentTime] = useState(new Date());
  
  // Data States
  const [revenueData, setRevenueData] = useState([]);
  const [arrearsData, setArrearsData] = useState([]);
  const [employmentData, setEmploymentData] = useState([]);
  const [tradeData, setTradeData] = useState([]);
  const [contractsData, setContractsData] = useState([]);
  const [investorsData, setInvestorsData] = useState([]);
  
  // Filter States
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPark, setSelectedPark] = useState("all");
  const [parksList, setParksList] = useState(["all"]);
  const [selectedYear, setSelectedYear] = useState("all");
  const [yearsList, setYearsList] = useState(["all"]);

  // Update time
  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);

  // Fetch Revenue Data
  useEffect(() => {
    const fetchRevenue = async () => {
      try {
        const resultData = await GetDataFromApiWithParams(`finances/revenuereport`);
        let dataArray = [];
        if (resultData && Array.isArray(resultData)) dataArray = resultData;
        else if (resultData?.data && Array.isArray(resultData.data)) dataArray = resultData.data;
        else if (resultData?.results && Array.isArray(resultData.results)) dataArray = resultData.results;
        console.log("KOKOKOKOKKOK",resultData)
        // console.log("KOKOKOKOKKOK",resultData.map(item=>item.payment_date))
        const formattedData = dataArray.map((item, index) => ({
          id: item.id || index,
          company_name: item.company_name || item.tenant_name || "N/A",
          park_name: item.park_name || item.park || "N/A",
          payment_mode: item.payment_mode || "USD",
          amount: parseFloat(item.amount) || parseFloat(item.payment_amount) || 0,
          month: item.month || (item.transaction_date ? format(new Date(item.transaction_date), 'MM') : "01"),
          year: new Date(item.payment_date).getFullYear() || (item.transaction_date ? format(new Date(item.transaction_date), 'yyyy') : "2026")
        }));
        setRevenueData(formattedData);
      } catch (error) {
        console.error("Failed to fetch revenue data:", error);
      }
    };
    fetchRevenue();
  }, []);

  // Fetch Arrear Data
  useEffect(() => {
    const fetchArrear = async () => {
      try {
        const resultData = await GetDataFromApiWithParams(`finances/arrearreport`);
        let dataArray = [];
        if (resultData && Array.isArray(resultData)) dataArray = resultData;
        else if (resultData?.data && Array.isArray(resultData.data)) dataArray = resultData.data;
       
        const formattedData = resultData.map(item => ({
          id: item.agreement_id,
          company_name: item.company_name || "N/A",
          park_name: item.park_name || item.park || "N/A",
          payment_mode: item.payment_mode || "USD",
          outstanding: parseFloat(item.outstanding) || 0,
          overdue_days: item.overdue_date || 0,
          month: item.month || "01",
          year: item.payment_date || "2026"
        }));
        setArrearsData(formattedData);
      } catch (error) {
        console.error("Failed to fetch arrears data:", error);
      }
    };
    fetchArrear();
  }, []);

  // Fetch Employment Data - Modified
  useEffect(() => {
    const fetchEmployment = async () => {
      try {
        // Fetch from both endpoints
        const [activityResult, employmentResult] = await Promise.all([
          GetDataFromApiWithParams(`investors/getemployment`),
          GetDataFromApiWithParams(`investors/getparkemployment`) // New endpoint for park_employment
        ]);
        
        let activityData = [];
        let parkEmploymentData = [];
        
        if (activityResult && Array.isArray(activityResult)) activityData = activityResult;
        else if (activityResult?.data && Array.isArray(activityResult.data)) activityData = activityResult.data;
        
        if (employmentResult && Array.isArray(employmentResult)) parkEmploymentData = employmentResult;
        else if (employmentResult?.data && Array.isArray(employmentResult.data)) parkEmploymentData = employmentResult.data;
        
        // Combine the data
        const combinedMap = new Map();
        
        // Add investor_activity data (created employment)
        activityData.forEach(item => {
          const key = item.investor_id || item.id;
          if (!combinedMap.has(key)) {
            combinedMap.set(key, {
              id: item.id || key,
              investor_id: key,
              company_name: item.company_name || `Company ${key}`,
              park_name: item.park_name || "N/A",
              emp_labor_female: 0,
              emp_labor_male: 0,
              emp_prof_female: 0,
              emp_prof_male: 0,
              year: item.year || "2024",
              month: item.month || "01"
            });
          }
          const existing = combinedMap.get(key);
          existing.emp_labor_female += parseInt(item.emp_labor_female) || 0;
          existing.emp_labor_male += parseInt(item.emp_labor_male) || 0;
          existing.emp_prof_female += parseInt(item.emp_prof_female) || 0;
          existing.emp_prof_male += parseInt(item.emp_prof_male) || 0;
        });
        
        // Add park_employment data (present employment)
        parkEmploymentData.forEach(item => {
          const key = item.investor_id || item.id;
          if (!combinedMap.has(key)) {
            combinedMap.set(key, {
              id: item.id || key,
              investor_id: key,
              company_name: item.company_name || `Company ${key}`,
              park_name: item.park_name || "N/A",
              emp_labor_female: 0,
              emp_labor_male: 0,
              emp_prof_female: 0,
              emp_prof_male: 0,
              year: item.year || "2024",
              month: item.month || "01"
            });
          }
          const existing = combinedMap.get(key);
          // Add present values
          existing.emp_labor_female += parseInt(item.labor_female) || 0;
          existing.emp_labor_male += parseInt(item.labor_male) || 0;
          existing.emp_prof_female += parseInt(item.professional_female) || 0;
          existing.emp_prof_male += parseInt(item.professional_male) || 0;
        });
        
        const combinedData = Array.from(combinedMap.values());
        setEmploymentData(combinedData);
        
      } catch (error) {
        console.error("Failed to fetch employment data:", error);
      }
    };
    fetchEmployment();
  }, []);

  // ==================== FIXED: Fetch Trade Data ====================
  // useEffect(() => {
  //   const fetchTrade = async () => {
  //     try {
  //       // Use the correct endpoint for trade data (approved investor activities)
  //       const resultData = await GetDataFromApiWithParams(`investors/allapproveInvestorsactivity`);
  //       let dataArray = [];
  //       if (resultData && Array.isArray(resultData)) dataArray = resultData;
  //       else if (resultData?.data && Array.isArray(resultData.data)) dataArray = resultData.data;
        
  //       console.log("Trade Data Response:", dataArray);
        
  //       const formattedData = dataArray.map(item => ({
  //         id: item.id || item.no,
  //         investor_id: item.investor_id,
  //         park_name: item.park_name || "N/A",
  //         export_amount: parseFloat(String(item.export_amount || '0').replace(/[$,]/g, '')) || 0,
  //         import_amount: parseFloat(String(item.import || '0').replace(/[$,]/g, '')) || 0,
  //         linkage_amount: parseFloat(String(item.linkage_money || '0').replace(/[$,]/g, '')) || 0,
  //         import_substitution: parseFloat(String(item.import_substitution || '0').replace(/[$,]/g, '')) || 0,
  //         year: item.recorded_on ? new Date(item.recorded_on).getFullYear() : 
  //               item.activity_period_to ? new Date(item.activity_period_to).getFullYear() : "2026"
  //       }));
        
  //       console.log("Formatted Trade Data:", formattedData);
  //       setTradeData(formattedData);
  //     } catch (error) {
  //       console.error("Failed to fetch trade data:", error);
  //     }
  //   };
  //   fetchTrade();
  // }, []);
//********************* */
// Fetch Trade Data - FIXED
useEffect(() => {
  const fetchTrade = async () => {
    try {
      // Use the new trade data endpoint
      const resultData = await GetDataFromApiWithParams(`investors/gettradedata`);
      let dataArray = [];
      if (resultData && Array.isArray(resultData)) dataArray = resultData;
      else if (resultData?.data && Array.isArray(resultData.data)) dataArray = resultData.data;
      
      console.log("Trade Data Response:", dataArray);
      
      const formattedData = dataArray.map(item => ({
        id: item.id || item.investor_id,
        investor_id: item.investor_id,
        park_name: item.park_name || "N/A",
        export_amount: parseFloat(String(item.export_amount || '0').replace(/[$,]/g, '')) || 0,
        import_amount: parseFloat(String(item.import || '0').replace(/[$,]/g, '')) || 0,
        linkage_amount: parseFloat(String(item.linkage_money || '0').replace(/[$,]/g, '')) || 0,
        import_substitution: parseFloat(String(item.import_substitution || '0').replace(/[$,]/g, '')) || 0,
        year: item.recorded_on ? new Date(item.recorded_on).getFullYear() : 
              item.activity_period_to ? new Date(item.activity_period_to).getFullYear() : "2026"
      }));
      
      console.log("Formatted Trade Data:", formattedData);
      setTradeData(formattedData);
    } catch (error) {
      console.error("Failed to fetch trade data:", error);
      setTradeData([]);
    }
  };
  fetchTrade();
}, []);
  // Fetch Contracts and Investors Data - FIXED VERSION
  useEffect(() => {
    const fetchData = async () => {
      try {
        const investorData = await GetDataFromApiWithParams(`investors/getinverstor`);
        const contractData = await GetDataFromApiWithParams(`agreements/allagreements`);
        
        let investors = [];
        let contracts = [];
        
        if (Array.isArray(investorData)) investors = investorData;
        else if (investorData?.data && Array.isArray(investorData.data)) investors = investorData.data;
        
        if (Array.isArray(contractData)) contracts = contractData;
        else if (contractData?.data && Array.isArray(contractData.data)) contracts = contractData.data;
        
        // FIXED: Include payment_mode from contract for each investor
        const transformedInvestors = investors.map(investor => {
          // Find matching contract to get payment_mode
          const matchingContract = contracts.find(c => 
            c.tenant_id === investor.id || 
            c.tenant_id === investor.investor_id ||
            c.investor_id === investor.id ||
            c.investor_id === investor.investor_id
          );
          
          return {
            id: investor.id || investor.investor_id,
            company_name: investor.company_name || "N/A",
            park_name: investor.park_name || "N/A",
            investment_type: investor.investment_type || "N/A",
            nationality: investor.nationality_origin || "Ethiopia",
            capital: parseFloat(investor.capital) || 0,
            payment_mode: matchingContract?.payment_mode || investor.payment_mode || "USD" // KEY FIX
          };
        });
        
        const transformedContracts = contracts.map(contract => ({
          id: contract.id || contract.agreement_id,
          company_name: contract.company_name || "N/A",
          park_name: contract.park_name || contract.park || "N/A",
          investment_type: contract.investment_type || "N/A",
          status: contract.status || "Active",
          monthly_rent: parseFloat(contract.monthly_rent) || 0,
          ownership_type: contract.ownership_type || "Leased"
        }));
        
        setInvestorsData(transformedInvestors);
        setContractsData(transformedContracts);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Generate unique parks and years
  useEffect(() => {
    const allParks = new Set();
    [...revenueData, ...arrearsData, ...employmentData, ...tradeData, ...investorsData, ...contractsData].forEach(item => {
      if (item.park_name && item.park_name !== "N/A") allParks.add(item.park_name);
    });
    setParksList(["all", ...Array.from(allParks).sort()]);
    
    const allYears = new Set();
    [...revenueData, ...arrearsData, ...employmentData, ...tradeData].forEach(item => {
      if (item.year) allYears.add(item.year);
    });
    setYearsList(["all", ...Array.from(allYears).sort().reverse()]);
  }, [revenueData, arrearsData, employmentData, tradeData, investorsData, contractsData]);

  // Filter data by park and year
  const filterByParkAndYear = useCallback((data, yearField = 'year', parkField = 'park_name') => {
    return data.filter(item => {
      const parkMatch = selectedPark === "all" || item[parkField] === selectedPark;
      const yearMatch = selectedYear === "all" || item[yearField] === selectedYear;
      const searchMatch = searchTerm === "" || 
        item.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.park_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.investor_id?.toString().includes(searchTerm);
      return parkMatch && yearMatch && searchMatch;
    });
  }, [selectedPark, selectedYear, searchTerm]);

 console.log("REVENUUUUUUUUUUUeeeeeeeeee", revenueData)
  const getMostRecentYear = useCallback(() => {
    const years = [...new Set(revenueData.map(r => r.year).filter(y => y && y !== "N/A"))];
    if (years.length === 0) return "2026";
    return years.sort().reverse()[0];
  }, [revenueData]);

  // Calculate metrics
  const metrics = useMemo(() => {
    const filteredRevenue = filterByParkAndYear(revenueData);
    const filteredArrears = filterByParkAndYear(arrearsData);
    const filteredEmployment = filterByParkAndYear(employmentData);
    const filteredTrade = tradeData;
    const filteredInvestors = filterByParkAndYear(investorsData, 'year', 'park_name');
    const filteredContracts = filterByParkAndYear(contractsData, 'year', 'park_name');
    
    // Revenue metrics
    const totalRevenueUSD = filteredRevenue.filter(r => normalizeCurrency(r.payment_mode) === "usd").reduce((sum, r) => sum + (r.amount || 0), 0);
    const totalRevenueETB = filteredRevenue.filter(r => normalizeCurrency(r.payment_mode) === "etb").reduce((sum, r) => sum + (r.amount || 0), 0);
    const totalOutstandingUSD = filteredArrears.filter(a => normalizeCurrency(a.payment_mode) === "usd").reduce((sum, a) => sum + (a.outstanding || 0), 0);
    const totalOutstandingETB = filteredArrears.filter(a => normalizeCurrency(a.payment_mode) === "etb").reduce((sum, a) => sum + (a.outstanding || 0), 0);
    const totalCollectedUSD = Math.max(0, totalRevenueUSD - totalOutstandingUSD);
    const collectionRate = totalRevenueUSD > 0 ? (totalCollectedUSD / totalRevenueUSD) * 100 : 0;
    
    // Employment metrics
    const totalLaborFemale = filteredEmployment.reduce((sum, e) => sum + (e.emp_labor_female || 0), 0);
    const totalLaborMale = filteredEmployment.reduce((sum, e) => sum + (e.emp_labor_male || 0), 0);
    const totalProfFemale = filteredEmployment.reduce((sum, e) => sum + (e.emp_prof_female || 0), 0);
    const totalProfMale = filteredEmployment.reduce((sum, e) => sum + (e.emp_prof_male || 0), 0);
    const totalEmployees = totalLaborFemale + totalLaborMale + totalProfFemale + totalProfMale;
    
    // Trade metrics
    const totalExport = filteredTrade.reduce((sum, t) => sum + (t.export_amount || 0), 0);
    const totalImport = filteredTrade.reduce((sum, t) => sum + (t.import_amount || 0), 0);
    const totalImportSubstitution = filteredTrade.reduce((sum, t) => sum + (t.import_substitution || 0), 0);
    const totalLinkage = filteredTrade.reduce((sum, t) => sum + (t.linkage_amount || 0), 0);
    const netTradeBalance = totalExport - totalImport;
    
    // Investor metrics - FIXED: Using normalizeCurrency for both USD and ETB
    const totalInvestors = filteredInvestors.length;
    const fdiCount = filteredInvestors.filter(i => i.nationality && i.nationality.toLowerCase() !== 'ethiopia').length;
    const localCount = totalInvestors - fdiCount;
    
    // FIXED: Use normalizeCurrency for consistent payment mode matching
    const totalCapitalUSD = filteredInvestors.filter(i => 
      normalizeCurrency(i.payment_mode) === "usd"
    ).reduce((sum, i) => sum + (i.capital || 0), 0);
    
    const totalCapitalETB = filteredInvestors.filter(i => 
      normalizeCurrency(i.payment_mode) === "etb"
    ).reduce((sum, i) => sum + (i.capital || 0), 0);
    
    // Contract metrics
    const totalContracts = filteredContracts.length;
    const activeContracts = filteredContracts.filter(c => c.status === "Active").length;
    
    return {
      totalRevenueUSD, totalRevenueETB, totalOutstandingUSD, totalOutstandingETB, collectionRate,
      totalLaborFemale, totalLaborMale, totalProfFemale, totalProfMale, totalEmployees,
      totalExport, totalImport, totalImportSubstitution, totalLinkage, netTradeBalance,
      totalInvestors, fdiCount, localCount, totalCapitalUSD, totalCapitalETB,
      totalContracts, activeContracts
    };
  }, [filterByParkAndYear, revenueData, arrearsData, employmentData, tradeData, investorsData, contractsData]);

  // Chart Data
  const chartData = useMemo(() => {
    const mostRecentYear = getMostRecentYear();
    
    // // Revenue by Park
    // const revenueByPark = {};
    // filterByParkAndYear(revenueData).forEach(r => {
    //   const park = r.park_name;
    //   if (park && park !== "N/A") {
    //     revenueByPark[park] = (revenueByPark[park] || 0) + (r.amount || 0);
    //   }
    // });
    // ==================== FIXED: Revenue by Park (ignore year filter) ====================
  const revenueByPark = {};
  // Filter by park and search term only, ignore year
  const revenueDataFiltered = revenueData.filter(item => {
    const parkMatch = selectedPark === "all" || item.park_name === selectedPark;
    const searchMatch = searchTerm === "" || 
      item.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.park_name?.toLowerCase().includes(searchTerm.toLowerCase());
    return parkMatch && searchMatch;
  });
  
  revenueDataFiltered.forEach(r => {
    const park = r.park_name;
    if (park && park !== "N/A") {
      revenueByPark[park] = (revenueByPark[park] || 0) + (r.amount || 0);
    }
  });
  // ==================== END OF FIX ====================
    
    // Outstanding by Park
    const outstandingByPark = {};
    filterByParkAndYear(arrearsData).forEach(a => {
      const park = a.park_name;
      if (park && park !== "N/A") {
        outstandingByPark[park] = (outstandingByPark[park] || 0) + (a.outstanding || 0);
      }
    });
    
    // Monthly Revenue Trend for the most recent year (USD only)
    const monthlyRevenue = {
      "Jan": 0, "Feb": 0, "Mar": 0, "Apr": 0, "May": 0, "Jun": 0,
      "Jul": 0, "Aug": 0, "Sep": 0, "Oct": 0, "Nov": 0, "Dec": 0
    };
    
    revenueData
      .filter(r => normalizeCurrency(r.payment_mode) === "usd" && r.year === mostRecentYear)
      .forEach(r => {
        const monthNum = r.month?.padStart(2, '0');
        const monthName = monthNames[monthNum];
        if (monthName && monthlyRevenue[monthName] !== undefined) {
          monthlyRevenue[monthName] += (r.amount || 0);
        }
      });
    
    // Employment by Park (Gender)
    const employmentByPark = {};
    filterByParkAndYear(employmentData).forEach(e => {
      const park = e.park_name;
      if (park && park !== "N/A") {
        if (!employmentByPark[park]) employmentByPark[park] = { female: 0, male: 0 };
        employmentByPark[park].female += (e.emp_labor_female || 0) + (e.emp_prof_female || 0);
        employmentByPark[park].male += (e.emp_labor_male || 0) + (e.emp_prof_male || 0);
      }
    });
    
    // ==================== FIXED: Investment Type Distribution from active contracts only ====================
    const investmentByType = {};
    
    // Get active contracts from contractsData
    const activeContracts = contractsData.filter(c => c.status === 'active' || c.status === 'Active');
    
    activeContracts.forEach(contract => {
      let type = contract.investment_type;
      if (type && type !== "N/A" && type !== "" && type !== "null" && type !== "undefined") {
        // Clean up the type name
        type = type.trim();
        investmentByType[type] = (investmentByType[type] || 0) + 1;
      }
    });
    
    // Add "Not Specified" category for active contracts without investment type
    const notSpecifiedCount = activeContracts.filter(c => 
      !c.investment_type || c.investment_type === "N/A" || c.investment_type === "" || c.investment_type === "null"
    ).length;
    
    if (notSpecifiedCount > 0) {
      investmentByType["Not Specified"] = notSpecifiedCount;
    }
    // ==================== END OF FIXED SECTION ====================
    
    // Export by Park (for horizontal bar chart)
    const exportByPark = {};
    filterByParkAndYear(tradeData).forEach(t => {
      const park = t.park_name;
      if (park && park !== "N/A") {
        exportByPark[park] = (exportByPark[park] || 0) + (t.export_amount || 0);
      }
    });
    
    // Trade Data by Park for Multi-Bar Chart
    console.log("Yearrrrrrr", mostRecentYear)
    const tradeByPark = {};
    tradeData
      .filter(t => t.year === mostRecentYear)
      .forEach(t => {
        const park = t.park_name;
        if (park && park !== "N/A") {
          if (!tradeByPark[park]) {
            tradeByPark[park] = { export: 0, import: 0, importSubstitution: 0 };
          }
          tradeByPark[park].export += (t.export_amount || 0);
          tradeByPark[park].import += (t.import_amount || 0);
          tradeByPark[park].importSubstitution += (t.import_substitution || 0);
        }
      });
    
    return { 
      revenueByPark, outstandingByPark, monthlyRevenue, employmentByPark, 
      investmentByType, exportByPark, tradeByPark, mostRecentYear 
    };
  }, [filterByParkAndYear, revenueData, arrearsData, employmentData, investorsData, tradeData, getMostRecentYear, contractsData]);

 console.log("YAHHHHHHHHHHHHH", chartData.tradeByPark)
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Loading dashboard data...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ bgcolor: '#f4f9ff', width: '98%', mx: '1%', py: 1 }}>
      {/* Header */}
      <Box sx={{ color: 'white', py: 2, px: 3 }}>
        <Container maxWidth="xl">
          <Box>
            <Grid item xs={12} md={12}>
              <IPDCWelcomeMessage messageTitle="Operation Management" />
            </Grid>
          </Box>
        </Container>
      </Box>

      {/* KPI Summary Cards */}
      <Container maxWidth="xl" sx={{ mt: 2 }}>
        <Grid container spacing={1.5}>
          {/* Total Capital Card - First Row */}
          <Grid item xs={12} sm={6} md={2.4} sx={{ display: 'flex', justifyContent: 'center' }}>
  <Card sx={{ bgcolor: '#e3f2fd', boxShadow: 1, minHeight: '70px', width: '100%' }}>
    <CardContent sx={{  '&:last-child': { pb: 1 }, textAlign: 'center' }}>
      <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1rem' }}>
        Total Capital
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1.5, my: 0.5 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '0.9rem', color: '#1a237e' }}>
          USD: {formatCurrency(metrics.totalCapitalUSD)}
        </Typography>
        <Divider orientation="vertical" flexItem sx={{ height: 25, borderColor: '#999' }} />
        <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '0.9rem', color: '#1a237e' }}>
          ETB: {formatCurrencyETB(metrics.totalCapitalETB)}
        </Typography>
      </Box>
    </CardContent>
  </Card>
</Grid>

          {/* Export / Import Card */}
          <Grid item xs={6} sm={4} md={2.4}>
            <Card sx={{ p: 2, bgcolor: '#e3f2fd', height: '100%', minHeight: 120 }}>
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1rem', pl: 2 }}>Export / Import</Typography>
              <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '0.9rem', color: '#1a237e', pl: 2 }}>E: {formatCurrency(metrics.totalExport)}</Typography>
              <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#1a237e', pl: 2 }}>I: {formatCurrency(metrics.totalImport)} | Sub: {formatCurrency(metrics.totalImportSubstitution)}</Typography>
            </Card>
          </Grid>

          {/* Investors Card */}
          <Grid item xs={6} sm={4} md={2.4}>
            <Card sx={{ p: 2, bgcolor: '#e3f2fd', height: '100%', minHeight: 120 }}>
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1rem', pl: 2 }}>Investors</Typography>
              <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#7b1fa2', pl: 2 }}>{metrics.totalInvestors}</Typography>
              <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#1a237e', pl: 2 }}>FDI: {metrics.fdiCount} | Local: {metrics.localCount}</Typography>
            </Card>
          </Grid>

          {/* Total Employment Card */}
          <Grid item xs={6} sm={4} md={2.4}>
            <Card sx={{ p: 2, bgcolor: '#e3f2fd', height: '100%', minHeight: 120 }}>
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1rem', pl: 2 }}>Total Employment</Typography>
              <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#1a237e', pl: 2 }}>{formatNumber(metrics.totalEmployees)}</Typography>
              <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#1a237e', pl: 2 }}>♀ {formatNumber(metrics.totalLaborFemale + metrics.totalProfFemale)} | ♂ {formatNumber(metrics.totalLaborMale + metrics.totalProfMale)}</Typography>
            </Card>
          </Grid>

         

          {/* Outstanding Card */}
          <Grid item xs={6} sm={4} md={2.4}>
            <Card sx={{ p: 2, bgcolor: '#e3f2fd', height: '100%', minHeight: 120 }}>
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 'bold', fontSize: '1rem', pl: 2 }}>Outstanding</Typography>
              <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#d32f2f', pl: 2 }}>USD: {formatCurrency(metrics.totalOutstandingUSD)}</Typography>
              <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '1rem', color: '#d32f2f', pl: 2 }}>ETB: {metrics.totalOutstandingETB}</Typography>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* Charts Section */}
      <Container maxWidth="xl" sx={{ mt: 2, mb: 3 }}>
        {/* Row 1: Donut Charts */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} md={4}>
            <DonutChartComponent 
              title="Revenue Distribution by Park (USD)"
              data={chartData.revenueByPark}
              colors={['#1976d2', '#2e7d32', '#ed6c02', '#9c27b0', '#d32f2f', '#0288d1']}
              formatValue={formatCurrency}
              total={metrics.totalRevenueUSD}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DonutChartComponent 
              title="Investment Type Distribution"
              data={chartData.investmentByType}
              colors={[
                '#1976d2', // Blue
                '#2e7d32', // Green
                '#ed6c02', // Orange
                '#9c27b0', // Purple
                '#d32f2f', // Red
                '#0288d1', // Light Blue
                '#7b1fa2', // Dark Purple
                '#e65100', // Dark Orange
                '#c2185b', // Pink
                '#00695c', // Teal
                '#f44336', // Red
                '#4caf50'  // Light Green
              ]}
              formatValue={formatNumber}
              total={Object.values(chartData.investmentByType).reduce((sum, count) => sum + count, 0)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <HorizontalBarChart 
              title="Outstanding Receivables by Park (USD)"
              data={Object.fromEntries(Object.entries(chartData.outstandingByPark).map(([k, v]) => [k, { value: v }]))}
              dataKey="value"
              color="#d32f2f"
              formatValue={formatCurrency}
            />
          </Grid>
        </Grid>
      <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} md={6}>
            <TradeMultiBarChart 
              title="Trade Activity by Park"
              data={chartData.tradeByPark}
              formatValue={formatCurrency}
              recentYear={chartData.mostRecentYear}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <StackedBarChartComponent 
              title="Employment Distribution by Park (Gender)"
              data={chartData.employmentByPark}
              formatValue={formatNumber}
            />
          </Grid>
        </Grid>
        {/* Row 2: Horizontal Bar Charts */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          
          <Grid item xs={12} md={6}>
            <MonthlyLineChart 
              title={`Monthly Revenue Trend (${chartData.mostRecentYear} - USD)`}
              monthlyData={chartData.monthlyRevenue}
              formatValue={formatCurrency}
              color="#1976d2"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <HorizontalBarChart 
              title="Export Performance by Park (USD)"
              data={Object.fromEntries(Object.entries(chartData.exportByPark).map(([k, v]) => [k, { value: v }]))}
              dataKey="value"
              color="#4caf50"
              formatValue={formatCurrency}
            />
          </Grid>
        </Grid>

        {/* Row 3: Trade Chart */}
        

        {/* Row 4: Capacity Analysis and Gap Analysis */}
        
      </Container>

      {/* Footer */}
      {/* <Box sx={{ bgcolor: '#1a237e', color: 'white', py: 1.5, textAlign: 'center' }}>
        <Typography variant="caption">© 2024 Investor Aftercare & Supervision Dashboard | All Rights Reserved</Typography>
      </Box> */}
    </Box>
  );
}